<template>
  <div class="clan-modal-wrapper" :class="{ 'dark-theme': isDark }">
    <!-- 宗门列表 -->
    <div v-if="showSectList" class="sect-map-shell">
      <div class="sect-map-hero">
        <div class="sect-map-hero__copy">
          <div class="sect-map-hero__eyebrow">山门初开</div>
          <div class="sect-map-toolbar">
            <div>
          <div class="sect-map-title">宗门势力图</div>
          <div class="sect-map-subtitle">点击地图中的宗门据点查看详情，未加入宗门时可直接申请加入。</div>
            </div>
            <div class="sect-map-legend">
              <span class="legend-item">
                <span class="legend-dot legend-dot--idle"></span>
                可查看
              </span>
              <span class="legend-item">
                <span class="legend-dot legend-dot--active"></span>
                当前选中
              </span>
            </div>
          </div>
        </div>
        <div class="sect-map-hero__quote">
          <div class="sect-map-hero__quote-label">山海录</div>
          <p>择一宗而入，修一脉而深。看重风格、资源与人脉，再决定你的归宿。</p>
        </div>
      </div>
      <div class="sect-world-map" :style="getSectMapStyle()">
        <div class="sect-world-map__backdrop"></div>
        <div class="sect-world-map__overlay"></div>
        <div
          v-for="item in sectMapList"
          :key="item.id"
          class="sect-marker"
          :class="{
            'is-active': selectedSectId === item.id,
            'is-my-sect': currentSect && currentSect.id === item.id
          }"
          :style="getSectMarkerStyle(item)"
          @click="openSectPreview(item)"
        >
          <div class="sect-marker__pulse"></div>
          <div class="sect-marker__core">
            <img :src="item.sectIcon" :alt="item.name" class="sect-marker__icon" />
          </div>
          <div class="sect-marker__label">
            <span class="sect-marker__name">{{ item.name }}</span>
            <span class="sect-marker__meta">{{ item.playerNum || 0 }}人</span>
          </div>
        </div>
      </div>
      <div class="sect-map-tip">还在为选择宗门而苦恼吗 ，欢迎加入天机阁！</div>
    </div>

    <div v-else-if="displaySect" class="main-clan-content">
      <div class="sect-detail-toolbar">
        <div class="sect-detail-toolbar__title">
          <span class="sect-detail-toolbar__eyebrow">宗门界面</span>
          <h3>{{ isViewingForeignSect ? `正在查看 ${displaySect.name}` : `${displaySect.name} 宗门总览` }}</h3>
        </div>
        <div class="sect-detail-toolbar__actions">
          <Button v-if="isViewingForeignSect && hasJoinedSect" @click="returnToHomeSect">返回我的宗门</Button>
          <Button type="primary" ghost @click="showWorldMap">返回大世界</Button>
        </div>
      </div>
      <!-- 移除了重复的Tabs标签 -->
      <div class="sect-mobile-tab-nav">
        <Button size="small" icon="ios-arrow-back" :disabled="mobileSectTabIndex <= 0" @click="switchSectTab(-1)">上一页</Button>
        <span>{{ mobileSectTabLabel }} <small>{{ mobileSectTabIndex + 1 }} / {{ mobileSectTabs.length }}</small></span>
        <Button size="small" icon="ios-arrow-forward" :disabled="mobileSectTabIndex >= mobileSectTabs.length - 1" @click="switchSectTab(1)">下一页</Button>
      </div>
      <div class="sect-workspace">
        <nav class="sect-workspace-nav" aria-label="宗门功能">
          <div class="sect-workspace-nav__title">宗门管理</div>
          <button
            v-for="tab in mobileSectTabs"
            :key="'workspace-' + tab.name"
            type="button"
            class="sect-workspace-nav__item"
            :class="{ active: activeTab === tab.name }"
            @click="activeTab = tab.name"
          >
            <span>{{ tab.label }}</span>
            <Icon type="ios-arrow-forward" />
          </button>
        </nav>
        <div class="sect-workspace-main">
          <Tabs v-model="activeTab" class="clan-tabs" :animated="false">
        <!-- 宗门信息 -->
        <TabPane label="宗门信息1" name="info">
          <div class="sect-info-panel">
            <div class="sect-header-info">
              <div class="sect-avatar-large">
                <img :src="displaySect.sectIcon" :alt="displaySect.name" />
<!--                <div class="sect-level">Lv.{{ displaySect.level || 1 }}</div>-->
              </div>
              <div class="sect-main-info">
                <div class="sect-title-row">
                  <h2 class="sect-title">{{ displaySect.name }}</h2>
                  <span class="sect-chip">{{ displaySect.playerNum || 0 }}名弟子</span>
                </div>
                <div class="sect-description-wrap">
                  <p class="sect-description">{{ displaySect.desci || '暂无宗门介绍' }}</p>
                  <button type="button" class="sect-description-more" @click="showSectDescriptionModal = true">展开全文</button>
                </div>
                <div class="sect-impression-row">
                  <span class="impression-pill">山门已立</span>
                  <span class="impression-pill">声望 {{ displaySect.reputation || 0 }}</span>
                  <span class="impression-pill">底蕴 {{ displaySect.capacity || 0 }}</span>
                </div>
                <div class="sect-stats-grid">
                  <div class="stat-item">
                    <div class="stat-content">
                      <div class="stat-label">宗门人数</div>
                      <div class="stat-value">{{ displaySect.playerNum || 0 }}</div>
                    </div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-content">
                      <div class="stat-label">宗门声望</div>
                      <div class="stat-value">{{ displaySect.reputation || 0 }}</div>
                    </div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-content">
                      <div class="stat-label">宗门实力</div>
                      <div class="stat-value">{{ displaySect.capacity || 0 }}</div>
                    </div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-content">
                      <div class="stat-label">{{ isViewingForeignSect ? '查看状态' : '我的贡献' }}</div>
                      <div class="stat-value">{{ isViewingForeignSect ? '外宗' : (myContribution || 0) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 宗门加成 -->
            <div class="sect-buffs">
              <h3 class="section-title">
                <i class="icon-buff"></i> 宗门加成
              </h3>
              <div class="buff-list">
                <div
                  v-for="(buff, index) in displaySect.sectBuffList || []"
                  :key="index"
                  class="buff-item"
                  :class="{ 'active': (displaySect.reputation || 0) >= buff.honorValue }"
                >
                  <div class="buff-header">
                    <span class="buff-name">声望 {{ buff.honorValue }}</span>
                    <span v-if="(displaySect.reputation || 0) >= buff.honorValue" class="buff-status">已激活</span>
                  </div>
                  <p class="buff-desc">{{ buff.sectDesc }}</p>
                </div>
              </div>
            </div>

            <!-- 宗门操作 -->
            <div v-if="!isViewingForeignSect" class="sect-actions-panel">
              <Button type="warning" @click="showExitConfirm">退出宗门</Button>
              <Button type="primary" @click="disiplePromotion">申请晋升</Button>
              <Button type="success" @click="sectRegistCompe">报名大比</Button>
              <Button type="info" icon="ios-trophy" @click="openCompePage">大比战报</Button>
            </div>
          </div>
        </TabPane>

        <!-- 宗门任务 -->
        <TabPane v-if="!isViewingForeignSect" label="宗门任务" name="sectTasks">
          <div class="sect-task-panel">
            
            <div class="sect-contribution-grid">
              <div class="contribution-card">
                <span>我的贡献</span>
                <strong>{{ myContribution || 0 }}</strong>
                <small>当前可用贡献</small>
              </div>
              <div class="contribution-card">
                <span>今日获取</span>
                <strong>{{ sectContributionSummary.todayContribution || 0 }}</strong>
                <small>任务、捐献、Boss排行</small>
              </div>
              <div class="contribution-card">
                <span>灵石捐献</span>
                <strong>{{ sectContributionSummary.todayCoinContribution || 0 }}/5</strong>
                <small>100灵石=1贡献</small>
              </div>
              <div class="contribution-card">
                <span>材料捐献</span>
                <strong>{{ sectContributionSummary.todayMaterialContribution || 0 }}/6</strong>
                <small>10材料=1贡献</small>
              </div>
            </div>

            <div class="sect-task-layout">
              <div class="sect-task-main panel-card">
                <div class="panel-card-head">
                  <h4>今日任务</h4>
                  <span>奖励保持低额，避免贡献膨胀</span>
                </div>
                <Spin v-if="sectTaskLoading" fix>加载中...</Spin>
                <div v-if="!sectTaskLoading && sectTaskList.length === 0" class="empty-hint">
                  暂无宗门任务，等待每日定时生成后再查看。
                </div>
                <div
                  v-for="task in sectTaskList"
                  :key="task.taskId"
                  class="sect-task-item"
                  :class="'status-' + normalizeTaskStatus(task.status)"
                >
                  <div class="task-item-top">
                    <div>
                      <h4>{{ task.taskName || task.name || '宗门任务' }}</h4>
                      <p v-html="task.taskDesci || task.taskDesc || ''"></p>
                    </div>
                    <Tag :color="getSectTaskStatusColor(task.status)">
                      {{ getSectTaskStatusText(task.status) }}
                    </Tag>
                  </div>
                  <div class="task-requirements">
                    <div
                      v-for="dtl in task.needRule || []"
                      :key="dtl.dtlId || (dtl.dtlNeedId + '-' + dtl.dtlType)"
                      class="task-requirement"
                    >
                      <span class="requirement-name">{{ getSectTaskRequirementText(dtl.dtlType) }} {{ dtl.dtlNeedName }}</span>
                      <span class="requirement-progress">{{ dtl.dtlSubNum || 0 }}/{{ dtl.dtlNeedNum || 0 }}</span>
                      <Button
                        v-if="isSectMaterialRequirement(dtl) && normalizeTaskStatus(task.status) === 1 && (dtl.dtlSubNum || 0) < (dtl.dtlNeedNum || 0)"
                        size="small"
                        type="success"
                        @click="openSectMatSubmit(dtl)"
                      >
                        提交材料
                      </Button>
                      <Button
                        v-if="isSectMapRequirement(dtl) && normalizeTaskStatus(task.status) === 1 && (dtl.dtlSubNum || 0) < (dtl.dtlNeedNum || 0)"
                        size="small"
                        type="primary"
                        @click="openSectTaskTarget(dtl)"
                      >
                        前往探索
                      </Button>
                      <Button
                        v-if="isSectMonsterRequirement(dtl) && normalizeTaskStatus(task.status) === 1 && (dtl.dtlSubNum || 0) < (dtl.dtlNeedNum || 0)"
                        size="small"
                        type="warning"
                        @click="openSectTaskTarget(dtl)"
                      >
                        前往讨伐
                      </Button>
                    </div>
                  </div>
                  <div class="task-item-bottom">
                    <span class="task-reward">贡献 +{{ task.sectContr || 0 }}</span>
                    <div class="task-actions">
                      <Button
                        v-if="normalizeTaskStatus(task.status) === 0"
                        size="small"
                        type="primary"
                        :loading="sectTaskActionId === task.taskId"
                        @click="receiveSectTask(task)"
                      >
                        接取
                      </Button>
                      <Button
                        v-if="normalizeTaskStatus(task.status) === 1"
                        size="small"
                        :loading="sectTaskActionId === task.taskId"
                        @click="refreshSectTask(task)"
                      >
                        刷新进度
                      </Button>
                      <Button
                        v-if="normalizeTaskStatus(task.status) === 2"
                        size="small"
                        type="success"
                        :loading="sectTaskActionId === task.taskId"
                        @click="claimSectTask(task)"
                      >
                        领取奖励
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="sect-task-side">
                <div class="panel-card donate-card">
                  <div class="panel-card-head">
                    <h4>贡献捐献</h4>
                    <span>低额补充获取途径</span>
                  </div>
                  <div class="donate-row">
                    <div class="donate-label">灵石</div>
                    <InputNumber v-model="sectCoinDonateNum" :min="100" :step="100" :max="500" size="small" />
                    <Button type="warning" size="small" :loading="sectDonateLoading" @click="donateSectCoin">
                      捐献
                    </Button>
                  </div>
                  <div class="donate-row donate-row--material">
                    <div class="donate-label">材料</div>
                    <Select v-model="sectDonateMaterialPackId" size="small" filterable clearable placeholder="选择材料">
                      <Option
                        v-for="item in sectMaterialList"
                        :key="item.packItemId"
                        :value="item.packItemId"
                      >
                        {{ item.itemName }} × {{ item.itemNum }}
                      </Option>
                    </Select>
                    <InputNumber v-model="sectDonateMaterialNum" :min="10" :step="10" size="small" />
                    <Button type="success" size="small" :loading="sectDonateLoading" @click="donateSectMaterial">
                      捐献
                    </Button>
                  </div>
                  <Button size="small" icon="ios-shirt-outline" @click="addEquit">
                    捐献高品质装备
                  </Button>
                </div>

                <div
                  v-for="panel in sectTaskRankPanels"
                  :key="panel.key"
                  class="panel-card rank-card"
                >
                  <div class="panel-card-head">
                    <h4>{{ panel.title }}</h4>
                    <span>{{ panel.subtitle }}</span>
                  </div>
                  <div v-if="panel.list.length === 0" class="empty-hint small">
                    {{ panel.emptyText }}
                  </div>
                  <div v-if="panel.list.length === 0 && panel.challengeable" class="rank-empty-actions">
                    <Button size="small" type="primary" ghost @click="challengeSectBossFromRank(panel)">
                      前往挑战
                    </Button>
                  </div>
                  <div
                    v-for="(row, index) in panel.list"
                    :key="panel.key + '-' + (row.charaId || row.mapId || index)"
                    class="rank-row"
                  >
                    <span class="rank-no">#{{ index + 1 }}</span>
                    <span class="rank-name">{{ row.roleName || row.charaName || row.name || row.charaId }}</span>
                    <div class="rank-actions">
                      <strong>{{ getSectRankValue(panel, row) }}</strong>
                      <Button
                        v-if="panel.challengeable"
                        size="small"
                        type="primary"
                        ghost
                        @click="challengeSectBossFromRank(row)"
                      >
                        挑战
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPane>

        <!-- 特殊建筑 -->
        <TabPane label="特殊建筑" name="specialBuilding">
          <div class="special-building-panel">
            <div class="special-building-toolbar">
              <div>
                <h4>{{ displaySect ? displaySect.name : '宗门' }}特殊建筑</h4>
                <span>建筑等级为全服共享，本宗与外宗消耗不同</span>
              </div>
              <Button size="small" icon="md-refresh" :loading="specialBuildingLoading" @click="loadSpecialBuildingPanel">
                刷新
              </Button>
            </div>

            <Spin v-if="specialBuildingLoading" fix>加载中...</Spin>
            <div v-if="!specialBuildingLoading && specialBuildingList.length === 0" class="empty-hint">
              当前宗门暂无特殊建筑配置。
            </div>

            <div class="special-building-layout" v-if="specialBuildingList.length">
              <div class="special-building-main">
                <div
                  v-for="building in specialBuildingList"
                  :key="building.buildingId"
                  class="special-building-card"
                >
                  <div class="special-building-card__head">
                    <div>
                      <div class="special-building-title-row">
                        <h4>{{ building.buildingName || '特殊建筑' }}</h4>
                        <Tag :color="building.isHomeSect ? 'green' : 'blue'" size="small">
                          {{ building.isHomeSect ? '本宗' : '外宗' }}
                        </Tag>
                      </div>
                      <p>{{ building.functionDesc || '暂无说明' }}</p>
                    </div>
                    <div class="special-building-level">
                      <span>等级</span>
                      <strong>{{ building.currentLevel || 1 }}</strong>
                    </div>
                  </div>

                  <div class="special-building-progress">
                    <div class="special-building-progress__meta">
                      <span>升级进度</span>
                      <strong>{{ building.currentProgress || 0 }}/{{ building.upgradeNeedNum || 0 }}</strong>
                    </div>
                    <Progress
                      :percent="getSpecialBuildingProgress(building)"
                      :stroke-width="8"
                      hide-info
                    />
                  </div>

                  <div class="special-building-desc-grid">
                    <div>
                      <span>当前效果</span>
                      <strong>{{ building.effectDesc || '暂无效果' }}</strong>
                    </div>
                    <div>
                      <span>本宗额外</span>
                      <strong>{{ building.ownExtraBonusDesc || '无' }}</strong>
                    </div>
                    <div>
                      <span>外宗门槛</span>
                      <strong>{{ getFavorLevelText(building.outerFavorLevel) }}</strong>
                    </div>
                    <div>
                      <span>当前好感</span>
                      <strong>{{ building.isHomeSect ? '本宗弟子' : getFavorLevelText(building.favorLevel) }}</strong>
                    </div>
                  </div>

                  <div class="special-building-actions">
                    <div class="special-building-action-line" v-if="getSpecialBuildingShop(building)">
                      <div>
                        <strong>兑换升级材料</strong>
                        <span>{{ getSpecialBuildingMaterialName(getSpecialBuildingShop(building)) }} × {{ getSpecialBuildingShop(building).itemNum || 1 }}</span>
                      </div>
                      <div class="special-building-action-control">
                        <span>{{ getSpecialBuildingShopCostText(getSpecialBuildingShop(building)) }}</span>
                        <InputNumber
                          v-model="specialBuildingExchangeNums[getSpecialBuildingShop(building).shopId]"
                          :min="1"
                          :max="getSpecialBuildingExchangeMax(getSpecialBuildingShop(building))"
                          size="small"
                        />
                        <Button
                          type="primary"
                          size="small"
                          :disabled="isSpecialBuildingShopDisabled(getSpecialBuildingShop(building))"
                          :loading="specialBuildingActionId === 'exchange-' + getSpecialBuildingShop(building).shopId"
                          @click="exchangeSpecialBuildingMaterial(getSpecialBuildingShop(building))"
                        >
                          兑换
                        </Button>
                      </div>
                    </div>

                    <div class="special-building-action-line" v-if="building.upgradeMaterialItemId">
                      <div>
                        <strong>提交升级材料</strong>
                        <span>背包可用 {{ getSpecialBuildingMaterialCount(building.upgradeMaterialItemId) }}</span>
                      </div>
                      <div class="special-building-action-control">
                        <InputNumber
                          v-model="specialBuildingDonateNums[building.buildingId]"
                          :min="1"
                          :max="Math.max(getSpecialBuildingMaterialCount(building.upgradeMaterialItemId), 1)"
                          size="small"
                        />
                        <Button
                          type="success"
                          size="small"
                          :disabled="getSpecialBuildingMaterialCount(building.upgradeMaterialItemId) <= 0"
                          :loading="specialBuildingActionId === 'donate-' + building.buildingId"
                          @click="donateSpecialBuildingMaterial(building)"
                        >
                          提交
                        </Button>
                      </div>
                    </div>

                    <div class="special-building-action-line" v-if="canUseSpecialBuilding(building)">
                      <div>
                        <strong>使用建筑</strong>
                        <span>{{ getSpecialBuildingUseHint(building) }}</span>
                      </div>
                      <div class="special-building-action-control">
                        <span class="special-building-use-cost">{{ getSpecialBuildingUseCostText(building) }}</span>
                        <Select
                          v-if="building.buildingCode === 'DUNGEON_FORMATION_HALL'"
                          v-model="specialBuildingUseOptions[building.buildingId]"
                          size="small"
                          style="width: 120px"
                        >
                          <Option value="DAMAGE_UP">增伤</Option>
                          <Option value="DAMAGE_REDUCE">减伤</Option>
                        </Select>
                        <Button
                          type="warning"
                          size="small"
                          :disabled="isSpecialBuildingUseDisabled(building)"
                          :loading="specialBuildingActionId === 'use-' + building.buildingId"
                          @click="useSpecialBuilding(building)"
                        >
                          使用
                        </Button>
                      </div>
                    </div>

                    <div class="special-building-action-line" v-if="isSpecialBuildingBusinessBuilding(building)">
                      <div>
                        <strong>{{ getSpecialBuildingBusinessTitle(building) }}</strong>
                        <span>{{ hasSpecialBuildingActiveState(building) ? '已开启，可查看今日商品' : '使用建筑后开放 8 小时' }}</span>
                      </div>
                      <div class="special-building-action-control">
                        <Button
                          type="primary"
                          size="small"
                          :disabled="!hasSpecialBuildingActiveState(building)"
                          :loading="specialBuildingActionId === 'load-business-' + building.buildingId"
                          @click="openSpecialBuildingBusinessModal(building)"
                        >
                          查看
                        </Button>
                      </div>
                    </div>

                    <div class="sect-hire-hall-panel" v-if="building.buildingCode === 'HIRE_HALL'">
                      <div v-if="building.isHomeSect" class="sect-hire-section">
                        <div class="sect-hire-section__head">
                          <strong>我的雇佣留影</strong>
                          <Button size="small" @click="loadSectHireHallPanel(building)">刷新</Button>
                        </div>
                        <div class="special-building-action-control">
                          <Select v-model="sectHireHallPublishForm.snapshotId" size="small" style="width: 180px" placeholder="选择留影">
                            <Option
                              v-for="snapshot in sectHireHallMySnapshots"
                              :key="snapshot.snapshotId"
                              :value="snapshot.snapshotId"
                            >
                              {{ snapshot.snapshotName || '未命名留影' }}
                            </Option>
                          </Select>
                          <InputNumber v-model="sectHireHallPublishForm.unitCoin" :min="1" size="small" placeholder="每小时灵石" />
                          <InputNumber v-model="sectHireHallPublishForm.expireHours" :min="1" :max="168" size="small" placeholder="上架小时" />
                          <Button
                            type="primary"
                            size="small"
                            :loading="specialBuildingActionId === 'hire-publish'"
                            @click="publishSectHireBounty(building)"
                          >
                            上架
                          </Button>
                        </div>
                        <div v-if="sectHireHallMyBounties.length === 0" class="empty-hint small">
                          暂无上架留影，可先在组队留影处生成留影后上架。
                        </div>
                        <div v-for="bounty in sectHireHallMyBounties" :key="bounty.bountyId" class="sect-hire-row">
                          <div>
                            <strong>{{ bounty.snapshotName || '未命名留影' }}</strong>
                            <span>{{ bounty.snapshotRealm || '' }} · {{ bounty.unitCoin || 0 }}灵石/小时 · 今日 {{ bounty.dailyRecruited || 0 }}/{{ bounty.dailyLimit || 0 }}</span>
                          </div>
                          <Button size="small" type="error" ghost @click="cancelSectHireBounty(bounty)">下架</Button>
                        </div>
                      </div>

                      <div v-else class="sect-hire-section">
                        <div class="sect-hire-section__head">
                          <strong>可雇佣留影</strong>
                          <Button size="small" @click="loadSectHireHallPanel(building)">刷新</Button>
                        </div>
                        <div v-if="sectHireHallBountyList.length === 0" class="empty-hint small">
                          当前暂无可雇佣留影。
                        </div>
                        <div v-for="bounty in sectHireHallBountyList" :key="bounty.bountyId" class="sect-hire-card">
                          <div class="sect-hire-card__meta">
                            <strong>{{ bounty.snapshotName || '未命名留影' }}</strong>
                            <span>{{ bounty.ownerName || bounty.ownerCharaId }} · {{ bounty.snapshotRealm || '' }} · 战力 {{ bounty.snapshotPower || 0 }}</span>
                            <span>{{ bounty.unitCoin || 0 }}灵石/小时 · 今日 {{ bounty.dailyRecruited || 0 }}/{{ bounty.dailyLimit || 0 }}</span>
                          </div>
                          <div class="special-building-action-control" v-if="sectHireHallOrderForms[bounty.bountyId]">
                            <Select v-model="sectHireHallOrderForms[bounty.bountyId].mapId" size="small" style="width: 160px" placeholder="挂机地图">
                              <Option
                                v-for="map in sectHireHallMapList"
                                :key="map.mapId"
                                :value="map.mapId"
                              >
                                {{ map.mapName }}
                              </Option>
                            </Select>
                            <InputNumber v-model="sectHireHallOrderForms[bounty.bountyId].hireHours" :min="1" :max="getSectHireHallMaxHours(building)" size="small" />
                            <span>{{ getSectHireOrderCostText(bounty) }}</span>
                            <Button
                              type="primary"
                              size="small"
                              :loading="specialBuildingActionId === 'hire-order-' + bounty.bountyId"
                              @click="createSectHireOrder(building, bounty)"
                            >
                              雇佣
                            </Button>
                          </div>
                        </div>
                      </div>

                      <div class="sect-hire-section">
                        <div class="sect-hire-section__head">
                          <strong>我的雇佣订单</strong>
                          <Button size="small" @click="loadSectHireHallOrders">刷新</Button>
                        </div>
                        <div v-if="sectHireHallOrderList.length === 0" class="empty-hint small">
                          暂无雇佣订单。
                        </div>
                        <div v-for="order in sectHireHallOrderList" :key="order.orderId" class="sect-hire-row">
                          <div>
                            <strong>{{ order.snapshotName || '雇佣留影' }}</strong>
                            <span>{{ order.mapName || ('地图' + order.mapId) }} · {{ order.hireHours }}小时 · {{ getSectHireOrderStatusText(order) }}</span>
                            <span v-if="order.rewardList && order.rewardList.length">奖励 {{ order.rewardList.length }}项 · 修为 {{ order.hirerExp || 0 }}</span>
                          </div>
                          <div class="special-building-action-control">
                            <Button size="small" :disabled="!order.canSettle" @click="settleSectHireOrder(order)">结算</Button>
                            <Button size="small" type="success" :disabled="Number(order.status) !== 3" @click="receiveSectHireOrder(order)">领取</Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="special-building-side">
                <div class="panel-card special-building-state-card">
                  <div class="panel-card-head">
                    <h4>当前生效</h4>
                    <span>个人状态</span>
                  </div>
                  <div v-if="specialBuildingStateList.length === 0" class="empty-hint small">
                    暂无生效建筑效果。
                  </div>
                  <div
                    v-for="state in specialBuildingStateList"
                    :key="state.id || (state.buildingId + '-' + state.stateType)"
                    class="special-building-state"
                  >
                    <strong>{{ state.buildingName || state.buildingCode }}</strong>
                    <span>{{ state.effectValue || getSpecialBuildingStateText(state) }}</span>
                    <small>{{ formatSpecialBuildingStateTime(state) }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPane>

        <!-- 散仙盟交流所 -->
        <TabPane v-if="isViewingSectTaskExchange" label="散仙盟交流所" name="sectFavor">
          <div class="sect-favor-panel">
            <div class="sect-favor-layout">
              <div class="panel-card sect-favor-list">
                <div class="panel-card-head">
                  <h4>宗门好感</h4>
                  <span>各宗门独立累计</span>
                </div>
                <Spin v-if="favorLoading" fix>加载中...</Spin>
                <div v-if="!favorLoading && sectFavorList.length === 0" class="empty-hint">
                  暂无好感度数据。
                </div>
                <div
                  v-for="sect in sectFavorList"
                  :key="sect.sectId || sect.id"
                  class="favor-sect-card"
                  :class="{ active: String(selectedFavorSectId) === String(sect.sectId || sect.id) }"
                  @click="selectFavorSect(sect.sectId || sect.id)"
                >
                  <div class="favor-sect-main">
                    <strong>{{ sect.sectName || sect.name || getSectNameById(sect.sectId || sect.id) }}</strong>
                    <Tag size="small" color="gold">{{ getFavorLevelText(sect.favorLevel) }}</Tag>
                  </div>
                  <div class="favor-progress-row">
                    <Progress :percent="getFavorProgressPercent(sect)" :stroke-width="6" hide-info />
                    <span>{{ sect.favorValue || 0 }}/{{ getFavorNextNeed(sect) }}</span>
                  </div>
                  <small>总好感 {{ sect.totalFavor || 0 }}</small>
                </div>
              </div>

              <div class="sect-favor-main">
                <div class="panel-card favor-task-card">
                  <div class="panel-card-head">
                    <h4>今日委托</h4>
                    <span>完成后获得对应宗门好感</span>
                  </div>
                  <div class="favor-toolbar">
                    <Button size="small" icon="md-refresh" :loading="favorTaskLoading" @click="loadFavorTasks">
                      刷新进度
                    </Button>
                    <Button size="small" type="warning" ghost :loading="favorActionId === 'refresh'" @click="refreshFavorTasks">
                      重置委托
                    </Button>
                  </div>
                  <Spin v-if="favorTaskLoading" fix>加载中...</Spin>
                  <div v-if="!favorTaskLoading && favorTaskList.length === 0" class="empty-hint">
                    当前宗门暂无可接委托。
                  </div>
                  <div
                    v-for="task in favorTaskList"
                    :key="task.taskId"
                    class="sect-task-item favor-task-item"
                    :class="'status-' + normalizeTaskStatus(task.status)"
                  >
                    <div class="task-item-top">
                      <div>
                        <h4>{{ task.taskName || task.name || '宗门委托' }}</h4>
                        <p v-html="task.taskDesci || task.taskDesc || ''"></p>
                      </div>
                      <Tag :color="getFavorTaskStatusColor(task.status)">
                        {{ getFavorTaskStatusText(task.status) }}
                      </Tag>
                    </div>
                    <div class="task-requirements">
                      <div
                        v-for="dtl in getFavorTaskNeedRules(task)"
                        :key="dtl.dtlId || (dtl.dtlNeedId + '-' + dtl.dtlType)"
                        class="task-requirement"
                      >
                        <span class="requirement-name">{{ getSectTaskRequirementText(dtl.dtlType) }} {{ dtl.dtlNeedName }}</span>
                        <span class="requirement-progress">{{ dtl.dtlSubNum || 0 }}/{{ dtl.dtlNeedNum || 0 }}</span>
                        <Button
                          v-if="isSectMaterialRequirement(dtl) && normalizeTaskStatus(task.status) === 1 && (dtl.dtlSubNum || 0) < (dtl.dtlNeedNum || 0)"
                          size="small"
                          type="success"
                          @click="openSectMatSubmit(dtl)"
                        >
                          提交材料
                        </Button>
                        <Button
                          v-if="isSectMapRequirement(dtl) && normalizeTaskStatus(task.status) === 1 && (dtl.dtlSubNum || 0) < (dtl.dtlNeedNum || 0)"
                          size="small"
                          type="primary"
                          @click="openSectTaskTarget(dtl)"
                        >
                          前往探索
                        </Button>
                        <Button
                          v-if="isSectMonsterRequirement(dtl) && normalizeTaskStatus(task.status) === 1 && (dtl.dtlSubNum || 0) < (dtl.dtlNeedNum || 0)"
                          size="small"
                          type="warning"
                          @click="openSectTaskTarget(dtl)"
                        >
                          前往讨伐
                        </Button>
                      </div>
                    </div>
                    <div class="task-item-bottom">
                      <span class="task-reward">好感 +{{ task.favorReward || 0 }}</span>
                      <div class="task-actions">
                        <Button
                          v-if="normalizeTaskStatus(task.status) === 0"
                          size="small"
                          type="primary"
                          :loading="favorActionId === task.taskId"
                          @click="acceptFavorTask(task)"
                        >
                          接取
                        </Button>
                        <Button
                          v-if="normalizeTaskStatus(task.status) === 1"
                          size="small"
                          :loading="favorActionId === task.taskId"
                          @click="refreshFavorTask(task)"
                        >
                          刷新进度
                        </Button>
                        <Button
                          v-if="normalizeTaskStatus(task.status) === 2"
                          size="small"
                          type="success"
                          :loading="favorActionId === task.taskId"
                          @click="claimFavorTask(task)"
                        >
                          领取好感
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="panel-card favor-shop-card">
                  <div class="panel-card-head">
                    <h4>好感兑换</h4>
                    <span>金币、灵石、神通、符箓、符箓材料</span>
                  </div>
                  <Spin v-if="favorShopLoading" fix>加载中...</Spin>
                  <div v-if="!favorShopLoading && favorShopList.length === 0" class="empty-hint">
                    当前宗门暂无兑换项。
                  </div>
                  <div class="favor-shop-grid">
                    <div
                      v-for="item in favorShopList"
                      :key="item.shopId"
                      class="favor-shop-item"
                      :class="{ locked: !item.unlocked }"
                    >
                      <div>
                        <div class="favor-shop-name">{{ item.itemName || ('道具 ' + item.itemId) }}</div>
                        <div class="favor-shop-meta">
                          <Tag size="small">{{ getFavorShopLevelText(item.unlockLevel) }}</Tag>
                          <span>× {{ item.itemNum || 1 }}</span>
                          <span v-if="item.weeklyLimit">本周 {{ item.weeklyUsed || 0 }}/{{ item.weeklyLimit }}</span>
                        </div>
                      </div>
                      <div class="favor-shop-action">
                        <strong>{{ item.costFavor || 0 }} 好感</strong>
                        <Button
                          size="small"
                          type="primary"
                          :disabled="isFavorShopExchangeDisabled(item)"
                          :loading="favorExchangeId === item.shopId"
                          @click="exchangeFavorShop(item)"
                        >
                          兑换
                        </Button>
                      </div>
                      <small v-if="!item.unlocked">{{ getFavorShopLockedText(item) }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPane>

        <!-- 宗门弟子 -->
        <TabPane label="宗门弟子" name="disciples" >
          <div class="disciples-panel">
            <div class="search-bar">
              <Input
                v-model="discipleSearch"
                placeholder="搜索弟子..."
                clearable
                @on-clear="searchDisciple"
                @on-enter="searchDisciple"
              >
                <Icon type="ios-search" slot="prefix" />
              </Input>
              <Button type="primary" @click="searchDisciple">搜索</Button>
            </div>

            <div v-if="loadingDisciples" class="disciples-list-state">正在加载弟子...</div>
            <div v-else class="disciples-list">
              <div
                v-for="(row, index) in filteredDisciples"
                :key="row.id || row.discipleId || index"
                class="disciple-list-row"
              >
                <div class="disciple-avatar">{{ (row.discipleName || '弟').slice(0, 1) }}</div>
                <div class="disciple-main">
                  <strong>{{ row.discipleName || '未知弟子' }}</strong>
                  <span>{{ row.discipleRealm || '未知境界' }} · {{ row.postion || '弟子' }}</span>
                </div>
                <div class="disciple-meta"><small>贡献</small><strong>{{ row.contribution || 0 }}</strong></div>
                <div class="disciple-meta disciple-map"><small>所在地图</small><span>{{ row.mapName || '未出行' }}</span></div>
                <div class="disciple-meta disciple-rank"><small>大比名次</small><span>{{ row.compeRank || '未上榜' }}</span></div>
                <div class="disciple-action">
                  <Button
                    v-if="!isViewingForeignSect"
                    type="primary"
                    size="small"
                    @click="duel(row.id)"
                    :loading="duelingId === row.id"
                  >
                    切磋
                  </Button>
                  <span v-else class="disciples-readonly-tag">仅查看</span>
                </div>
              </div>
              <div v-if="filteredDisciples.length === 0" class="disciples-list-state">暂无弟子数据</div>
            </div>

            <Page
              :total="discipleTotal"
              :current="discipleCurrentPage"
              :page-size="disciplePageSize"
              @on-change="changePage"
              show-total
              class="disciples-pagination"
            />
          </div>
        </TabPane>

        <!-- 宗门宝库 -->
        <TabPane v-if="!isViewingForeignSect" label="宗门宝库" name="treasure">
          <div class="treasure-panel">
            <div class="treasure-search">
              <div class="simple-search-container">
                <Input
                  v-model="treasureSearch.name"
                  placeholder="法器名称"
                  clearable
                  class="search-field"
                />
                <Input
                  v-model="treasureSearch.element"
                  placeholder="法器元素"
                  clearable
                  class="search-field"
                />
                <Input
                  v-model="treasureSearch.level"
                  type="number"
                  placeholder="等级"
                  clearable
                  class="search-field number-field"
                />
                <Select
                  v-model="treasureSearch.sectId"
                  clearable
                  placeholder="宗门"
                  class="search-field select-field"
                >
                  <Option
                    v-for="sect in sectItemList2"
                    :key="sect.id"
                    :value="sect.id"
                  >
                    {{ sect.name }}
                  </Option>
                </Select>
                <Button
                  type="primary"
                  icon="ios-search"
                  class="action-btn"
                  @click="searchTreasure"
                >
                  搜索
                </Button>
              </div>
            </div>

            <div class="treasure-list">
              <div
                v-for="(item, index) in treasureList"
                :key="index"
                class="treasure-item"
                :class="getTreasureClass(item)"
              >
                <div class="treasure-header">
                  <div class="treasure-name">{{ item.itemName }}</div>
                  <div class="treasure-type">{{ getItemType(item.kind) }}</div>
                </div>
                <div class="treasure-info">
                  <div class="info-row">
                    <span class="info-label">等级:</span>
                    <span class="info-value">{{ item.level }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">元素:</span>
                    <span class="info-value">{{ item.weaponTypeDec }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">品阶:</span>
                    <span class="info-value grade-tag" :class="`grade-${getStarCount(item.scoreLevel) || 1}`">
                      {{ item.scoreLevel }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">贡献点:</span>
                    <span class="info-value contri-point">{{ item.contriPoint || 0 }}</span>
                  </div>
                </div>
                <div class="treasure-actions">
                  <Button
                    type="default"
                    size="small"
                    icon="ios-eye"
                    @click="showTreasureDetail(item)"
                  >
                    查看
                  </Button>
                  <Button
                    type="success"
                    size="small"
                    icon="ios-swap"
                    @click="exchangeTreasure(item, index)"
                    :loading="exchangingIndex === index"
                  >
                    兑换
                  </Button>
                </div>
              </div>
            </div>

            <Page
              :total="treasureTotal"
              :current="treasureCurrentPage"
              :page-size="treasurePageSize"
              @on-change="changeTreasurePage"
              show-total
              class="treasure-pagination"
            />
          </div>
        </TabPane>

        <!-- 藏宝阁 -->
        <TabPane v-if="!isViewingForeignSect" label="藏宝阁" name="treasureHall">
          <div class="treasure-hall-panel">
            <Alert type="warning" show-icon>
              注意：宗门仓库/藏宝阁兑换心法后会自动学习，若不满足学习条件将直接拦截兑换
            </Alert>

            <div class="treasure-hall-list">
              <div
                v-for="(item, index) in treasureHallList"
                :key="index"
                class="treasure-hall-item"
              >
                <div class="treasure-hall-icon"><Icon type="ios-archive-outline" /></div>
                <div class="treasure-hall-main">
                  <div class="treasure-hall-head">
                    <h4 class="item-name">{{ item.syntheticName }}</h4>
                    <span class="treasure-hall-status">宗门珍藏</span>
                  </div>
                  <div class="treasure-hall-meta">
                    <span>需要职位：{{ item.syntheticPostion }}</span>
                    <span>兑换 {{ item.syntheticNum }} 次</span>
                    <span>贡献 {{ item.syntheticMoney }}</span>
                    <span v-if="item.syntheticCoin">灵石 {{ item.syntheticCoin }}</span>
                  </div>
                  <div v-if="item.materOneName || item.materTwoName || item.materThreeName" class="treasure-hall-materials">
                    <span v-if="item.materOneName" class="material">
                    {{ item.materOneName }} × {{ item.materOneNum }}
                    </span>
                    <span v-if="item.materTwoName" class="material">
                    {{ item.materTwoName }} × {{ item.materTwoNum }}
                    </span>
                    <span v-if="item.materThreeName" class="material">
                    {{ item.materThreeName }} × {{ item.materThreeNum }}
                    </span>
                  </div>
                </div>
                <div class="item-actions">
                  <Button
                    type="success"
                    size="small"
                    @click="exchangeTreasureHall(item, index)"
                    :loading="exchangingHallIndex === index"
                  >
                    兑换
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </TabPane>

        <!-- 宗门心法 -->
        <TabPane v-for="(list, index) in visibleXinfaLists" :key="index" :label="list.name" :name="'xinfa' + (index + 1)">
          <div class="xinfa-panel">
            <Alert type="info" show-icon>
              注意：心法必须上一重掌握才能开始修炼下一重。修炼心法期间，地图战斗不获取修为但增加熟练度
            </Alert>

            <div class="xinfa-list">
              <div
                v-for="(item, idx) in list.items"
                :key="idx"
                class="xinfa-item"
                :class="{
                  'learned': item.learn === 1,
                  'mastered': item.grasp === 1
                }"
              >
                <div class="xinfa-header">
                  <h4 class="xinfa-name">{{ item.xinfaName }}</h4>
                  <div class="xinfa-type">{{ item.xinfaTypeDesc }}</div>
                </div>
                <p class="xinfa-desc">{{ item.xinfaDesc }}</p>
                <div class="xinfa-progress">
                  <div class="progress-info">
                    熟练度: {{ item.mastery || 0 }}/{{ item.masteryNeed || 0 }}
                  </div>
                  <Progress
                    :percent="item.mastery && item.masteryNeed ? Math.round((item.mastery / item.masteryNeed) * 100) : 0"
                    :stroke-width="6"
                  />
                </div>
                <div class="xinfa-status">
                  <span v-if="item.grasp === 1" class="status-tag mastered">已掌握</span>
                  <span v-if="item.learn === 1" class="status-tag learning">修炼中</span>
                </div>
                <div class="xinfa-actions">
                  <template v-if="item.id">
                    <Button
                      v-if="item.learn === 1"
                      type="warning"
                      size="small"
                      @click="xiulian(item, index + 1, 0)"
                    >
                      停止修炼
                    </Button>
                    <Button
                      v-else-if="item.grasp !== 1"
                      type="primary"
                      size="small"
                      @click="xiulian(item, index + 1, 1)"
                    >
                      开始修炼
                    </Button>
                    <Button
                      v-else-if="item.grasp === 1"
                      type="error"
                      size="small"
                      @click="forgetXinfa(item, index + 1)"
                    >
                      遗忘心法
                    </Button>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </TabPane>

        <!-- 留言板 -->
        <TabPane v-if="!isViewingForeignSect" label="留言板" name="messageBoard">
          <div class="message-board-panel">
            <div class="message-actions">
              <Button type="info" icon="ios-chatbubbles" @click="showAddMessage">
                留音石 (10贡献点/次)
              </Button>
            </div>

            <div class="message-list">
              <div
                v-for="(message, index) in messageList"
                :key="index"
                class="message-item"
              >
                <div class="message-header">
                  <span class="message-author">{{ message.name }} </span>
                  <span class="message-time">{{ formatTime(message.createTime) }}</span>
                  <Button v-if="message.recordId" type="primary" size="small" @click="showMessageAction2(message)">
                    回放
                  </Button>

                </div>
                <div class="message-content">
                  {{ message.content }}
                </div>
                <div v-if="message.name !== '飘渺宗' && message.name !== '无极宗' &&
                          message.name !== '黯幽阁' && message.name !== '玄天宗'"
                     class="message-actions">
                  <Button type="primary" size="small" @click="showMessageAction(message)">
                    点化
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </TabPane>
          </Tabs>
        </div>
      </div>
    </div>

    <Modal v-model="showSectDescriptionModal" :title="(displaySect ? displaySect.name : '宗门') + '简介'" width="560" footer-hide>
      <div class="sect-description-full">{{ displaySect ? (displaySect.desci || '暂无宗门介绍') : '暂无宗门介绍' }}</div>
    </Modal>

    <!-- 加载中状态 -->
    <div v-if="!showSectList && !displaySect" class="loading-state">
      <Spin size="large" fix>加载宗门数据中...</Spin>
    </div>

    <!-- 子弹窗保持不变 -->
    <!-- ... 其他Modal代码 ... -->
    <!-- 子弹窗 -->
    <!-- 捐献装备 -->
    <Modal v-model="showDonateModal" title="捐献装备" @on-ok="confirmDonate">
      <div class="donate-modal-content">
        <RadioGroup v-model="selectedDonateItem" vertical>
          <Radio
            v-for="(item, index) in donateableItems"
            :key="index"
            :label="item.packItemId"
            :disabled="loadingDonate"
          >
            <span class="item-name">{{ item.itemName }}</span>
            <span class="item-grade">品阶 {{ item.scoreLevel }}</span>
          </Radio>
        </RadioGroup>
        <div v-if="donateableItems.length === 0" class="no-items">
          暂无符合条件的装备可捐献
        </div>
      </div>
    </Modal>

    <!-- 宗门任务材料提交 -->
    <Modal v-model="showSectMatSubmitModal" title="提交宗门任务材料" @on-ok="submitSectTaskMaterial">
      <div class="donate-modal-content">
        <div class="submit-task-tip">
          需求：{{ currentSectTaskNeed ? currentSectTaskNeed.dtlNeedName : '' }}
          × {{ currentSectTaskNeed ? currentSectTaskNeed.dtlNeedNum : 0 }}
        </div>
        <Select v-model="sectSubmitMaterialPackId" filterable clearable placeholder="选择可提交材料">
          <Option
            v-for="item in sectSubmitMaterialList"
            :key="item.packItemId"
            :value="item.packItemId"
          >
            {{ item.itemName }} × {{ item.itemNum }}
          </Option>
        </Select>
        <InputNumber
          v-model="sectSubmitMaterialNum"
          :min="1"
          :max="getSectSubmitMaterialMax()"
          style="width: 100%; margin-top: 12px;"
        />
      </div>
    </Modal>

    <!-- 兑换确认 -->
    <Modal v-model="showExchangeConfirm" title="兑换确认" @on-ok="confirmExchange">
      <p>确定兑换该法器吗？</p>
    </Modal>

    <!-- 退出确认 -->
    <Modal v-model="showExitConfirmModal" title="退出宗门" @on-ok="confirmExit">
      <p>退出宗门将清空所有贡献，是否确认退出？</p>
    </Modal>

    <!-- 留言框 -->
    <Modal v-model="showMessageModal" title="留音石" @on-ok="confirmAddMessage">
      <Input
        v-model="messageContent"
        type="textarea"
        :rows="4"
        placeholder="请输入留言内容 (10贡献点/次)"
        :maxlength="500"
        show-word-limit
      />
    </Modal>

    <Modal
      v-model="showSpecialBuildingBusinessModal"
      :title="getSpecialBuildingBusinessTitle(currentSpecialBuildingBusinessBuilding)"
      width="620"
      footer-hide
    >
      <div class="special-building-business-modal">
        <Spin v-if="specialBuildingActionId === 'load-business-' + (currentSpecialBuildingBusinessBuilding && currentSpecialBuildingBusinessBuilding.buildingId)" fix />
        <div v-if="getSpecialBuildingBusinessGoods(currentSpecialBuildingBusinessBuilding).length === 0" class="empty-hint small">
          暂无可用商品。
        </div>
        <div
          v-for="goods in getSpecialBuildingBusinessGoods(currentSpecialBuildingBusinessBuilding)"
          :key="goods.dailyGoodsId || goods.formulaId || goods.itemId"
          class="special-building-business__item"
        >
          <div>
            <strong>{{ getSpecialBuildingBusinessGoodsName(goods) }}</strong>
            <span>{{ getSpecialBuildingBusinessGoodsMeta(goods) }}</span>
          </div>
          <div class="special-building-business__action">
            <Tag color="gold">{{ goods.viewCostText || '价格待配置' }}</Tag>
            <Button
              type="primary"
              size="small"
              :disabled="Number(goods.stock || 0) <= 0"
              :loading="specialBuildingActionId === 'business-' + currentSpecialBuildingBusinessBuilding.buildingId + '-' + goods.dailyGoodsId"
              @click="exchangeSpecialBuildingBusinessGoods(currentSpecialBuildingBusinessBuilding, goods)"
            >
              {{ currentSpecialBuildingBusinessBuilding && currentSpecialBuildingBusinessBuilding.buildingCode === 'ALCHEMY_HOUSE' ? '学习' : '兑换' }}
            </Button>
          </div>
        </div>
      </div>
    </Modal>

    <!-- 装备详情 -->
    <Modal v-model="showItemDetail" title="装备详情" width="400" footer-hide>
      <div v-if="selectedItem" class="item-detail">
        <h3 :style="{ color: getItemColor(selectedItem.color) }">{{ selectedItem.itemName }}</h3>
        <div class="item-basic">
          <p v-if="selectedItem.basicSocre != null">
            灵气: {{ selectedItem.basicSocre }}+{{ selectedItem.appraisaScore }}
            <br>品阶: {{ selectedItem.scoreLevel }}
          </p>
          <p>强化上限: {{ selectedItem.maxStrengthen }}</p>
          <p>洗练上限: {{ selectedItem.appraisalNum }}</p>
          <p>装备类型: {{ selectedItem.typeDec }}</p>
          <p>法器元素: {{ selectedItem.weaponTypeDec }}</p>
          <p>装备等级: {{ selectedItem.level }}</p>
          <p>鉴定状态: {{ selectedItem.appraisal == 1 ? "已鉴定" : "未鉴定" }}</p>
        </div>

        <!-- 属性显示 -->
        <div class="item-attributes">
          <div v-for="attr in getItemAttributes(selectedItem)" :key="attr.label" class="attribute">
            <span class="attr-label">{{ attr.label }}:</span>
            <span class="attr-value">{{ attr.value }}</span>
          </div>
        </div>

        <!-- 其他信息 -->
        <div v-if="selectedItem.affixVoList" class="item-affixes">
          <Divider>附加属性</Divider>
          <div v-for="affix in selectedItem.affixVoList" :key="affix.affixDescribe"
               :style="{ color: affix.affixLevel == 'T1' ? '#ff8c00' : 'rgb(73, 193, 248)' }">
            【{{ affix.affixLevel }}】 {{ affix.affixDescribe }}
          </div>
        </div>
      </div>
    </Modal>

    <Modal
      v-model="showSectPreview"
      :title="selectedMapSect ? selectedMapSect.name : '宗门详情'"
      width="520"
      :footer-hide="true"
      class="sect-preview-modal"
    >
      <div v-if="selectedMapSect" class="sect-preview-card">
        <div class="sect-preview-card__head">
          <div class="sect-preview-card__avatar">
            <img :src="selectedMapSect.sectIcon" :alt="selectedMapSect.name" />
          </div>
          <div class="sect-preview-card__info">
            <div class="sect-preview-card__name">{{ selectedMapSect.name }}</div>
            <div class="sect-preview-card__stats">
              <span>人数 {{ selectedMapSect.playerNum || 0 }}</span>
              <span>声望 {{ selectedMapSect.reputation || 0 }}</span>
              <span>实力 {{ selectedMapSect.capacity || 0 }}</span>
            </div>
          </div>
        </div>
        <div class="sect-preview-card__section">
          <div class="sect-preview-card__label">宗门简介</div>
          <div class="sect-preview-card__desc">{{ selectedMapSect.desci || '暂无介绍' }}</div>
        </div>
        <div class="sect-preview-card__section">
          <div class="sect-preview-card__label">入门条件</div>
          <div class="sect-preview-card__requirement">{{ getSectRequirementText(selectedMapSect) }}</div>
        </div>
        <div class="sect-preview-card__actions">
          <Button @click="showSectPreview = false">关闭</Button>
          <Button
            type="primary"
            :loading="joiningSectId === selectedMapSect.id"
            @click="handleSectPrimaryAction(selectedMapSect)"
          >
            {{ getSectPrimaryActionText(selectedMapSect) }}
          </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { sleep } from "../utils";
import sectWorldMap from "@/assets/sect-world-map.png";

export default {
  name: 'ClanModal',
  props: {
    isDark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSectList: false,
      sectEject2: false,
      activeTab: 'disciples',
      currentSect: null,
      homeSect: null,
      viewingSect: null,
      sectList2: [],
      sectItemList2: [],
      selectedSectId: null,
      selectedMapSect: null,
      showSectPreview: false,
      showSectDescriptionModal: false,
      joiningSectId: null,
      sectWorldMap,
      sectMapPositions: {
        "星月阁": { top: "23%", left: "12%" },
        "开山宗": { top: "18%", left: "20%" },
        "御灵宗": { top: "31%", left: "30%" },
        "玄天宗": { top: "42%", left: "19%" },
        "无极宗": { top: "52%", left: "31%" },
        "散仙盟": { top: "61%", left: "10%" },
        "青云宗": { top: "77%", left: "25%" },
        "青云门": { top: "77%", left: "25%" },
        "缥缈宗": { top: "84%", left: "33%" },
        "飘渺宗": { top: "84%", left: "33%" },
        "天机阁": { top: "83%", left: "46%" },
        "黯幽阁": { top: "84%", left: "65%" },
        "踏幽阁": { top: "84%", left: "65%" }
      },
      myContribution: 0,
      discipleSearch: '',
      discipleColumns: [
        { title: '弟子名称', key: 'discipleName', minWidth: 120 },
        { title: '境界', key: 'discipleRealm', width: 100 },
        { title: '贡献值', key: 'contribution', width: 100, sortable: true },
        { title: '职位', key: 'postion', width: 100 },
        { title: '所在地图', key: 'mapName', width: 150 },
        { title: '大比名次', key: 'compeRank', width: 100 },
        { title: '操作', slot: 'action', width: 100, align: 'center' }
      ],
      discipleTableData: [],
      discipleTempData: [],
      discipleCurrentPage: 1,
      discipleTotal: 0,
      disciplePageSize: 15,
      loadingDisciples: false,
      duelingId: null,
      treasureSearch: {
        name: '',
        element: '',
        level: '',
        sectId: null
      },
      treasureList: [],
      treasureCurrentPage: 1,
      treasureTotal: 0,
      treasurePageSize: 20,
      treasureHallList: [],
      xinfaLists: [
        { name: '心法一', items: [] },
        { name: '心法二', items: [] },
        { name: '心法三', items: [] }
      ],
      messageList: [],
      messageContent: '',
      sectTaskList: [],
      sectContributionSummary: {},
      sectContributionRank: [],
      sectBossRank: [],
      sectTaskLoading: false,
      sectContributionLoading: false,
      sectTaskActionId: null,
      sectCoinDonateNum: 100,
      sectDonateMaterialPackId: '',
      sectDonateMaterialNum: 10,
      sectDonateLoading: false,
      sectMaterialList: [],
      showSectMatSubmitModal: false,
      currentSectTaskNeed: null,
      sectSubmitMaterialPackId: '',
      sectSubmitMaterialNum: 1,
      sectSubmitMaterialList: [],
      sectFavorOverview: {},
      sectFavorList: [],
      selectedFavorSectId: null,
      favorTaskList: [],
      favorShopList: [],
      favorLoading: false,
      favorTaskLoading: false,
      favorShopLoading: false,
      favorActionId: null,
      favorExchangeId: null,
      specialBuildingOverview: {},
      specialBuildingList: [],
      specialBuildingShopList: [],
      specialBuildingStateList: [],
      scriptureHallGoodsList: [],
      alchemyHouseGoodsList: [],
      showSpecialBuildingBusinessModal: false,
      currentSpecialBuildingBusinessBuilding: null,
      specialBuildingLoading: false,
      specialBuildingActionId: null,
      specialBuildingExchangeNums: {},
      specialBuildingDonateNums: {},
      specialBuildingUseOptions: {},
      sectHireHallMySnapshots: [],
      sectHireHallMyBounties: [],
      sectHireHallBountyList: [],
      sectHireHallMapList: [],
      sectHireHallOrderList: [],
      sectHireHallPublishForm: {
        snapshotId: '',
        unitCoin: 100,
        expireHours: 72
      },
      sectHireHallOrderForms: {},
      showDonateModal: false,
      donateableItems: [],
      selectedDonateItem: '',
      loadingDonate: false,
      showExchangeConfirm: false,
      exchangingItem: null,
      exchangingIndex: null,
      exchangingHallIndex: null,
      showExitConfirmModal: false,
      showMessageModal: false,
      showItemDetail: false,
      selectedItem: null
    }
  },
  computed: {
    hasJoinedSect() {
      return !!this.homeSect;
    },
    isViewingForeignSect() {
      return !!(this.viewingSect && (!this.homeSect || this.viewingSect.id !== this.homeSect.id));
    },
    isViewingSectTaskExchange() {
      const sect = this.displaySect || {};
      const sectId = sect.id || sect.sectId;
      const sectName = sect.name || sect.sectName;
      return String(sectId) === '10009' || sectName === '散仙盟';
    },
    displaySect() {
      return this.viewingSect || this.homeSect || this.currentSect || null;
    },
    visibleXinfaLists() {
      return this.isViewingForeignSect ? [] : this.xinfaLists;
    },
    mobileSectTabs() {
      const tabs = [{ name: 'info', label: '宗门信息' }, { name: 'disciples', label: '宗门弟子' }, { name: 'specialBuilding', label: '特殊建筑' }];
      if (!this.isViewingForeignSect) tabs.push({ name: 'sectTasks', label: '宗门任务' });
      if (this.isViewingSectTaskExchange) tabs.push({ name: 'sectFavor', label: '交流所' });
      if (!this.isViewingForeignSect) {
        tabs.push({ name: 'treasure', label: '宗门宝库' }, { name: 'treasureHall', label: '藏宝阁' });
        this.visibleXinfaLists.forEach((list, index) => tabs.push({ name: 'xinfa' + (index + 1), label: list.name }));
        tabs.push({ name: 'messageBoard', label: '留言板' });
      }
      return tabs;
    },
    mobileSectTabIndex() {
      const index = this.mobileSectTabs.findIndex(item => item.name === this.activeTab);
      return index < 0 ? 0 : index;
    },
    mobileSectTabLabel() {
      return (this.mobileSectTabs[this.mobileSectTabIndex] || {}).label || '宗门信息';
    },
    filteredDisciples() {
      const sourceList = Array.isArray(this.discipleTableData) ? this.discipleTableData : [];
      if (!this.discipleSearch) {
        const start = (this.discipleCurrentPage - 1) * this.disciplePageSize;
        const end = this.discipleCurrentPage * this.disciplePageSize;
        return sourceList.slice(start, end);
      }
      return sourceList.filter(item => {
        const name = item.discipleName || '';
        return name.toLowerCase().includes(this.discipleSearch.toLowerCase());
      });
    },
    sectMapList() {
      return (this.sectList2 || []).map((item, index) => ({
        ...item,
        mapPosition: this.getSectPosition(item, index)
      }));
    },
    sectTaskRankPanels() {
      const bossPanels = (Array.isArray(this.sectBossRank) ? this.sectBossRank : []).map(group => ({
        key: `sectBoss-${group.mapId || group.bossName || 'default'}`,
        title: group.title || this.resolveSectBossPanelTitle(group),
        subtitle: group.subtitle || '按今日累计伤害统计',
        emptyText: '暂无Boss排行数据',
        challengeable: true,
        mapId: group.mapId,
        mapName: group.mapName,
        bossName: group.bossName,
        minLv: group.minLv,
        maxLv: group.maxLv,
        list: Array.isArray(group.rankList) ? group.rankList : []
      }));
      const panels = [
        {
          key: 'contribution',
          title: '今日贡献排行',
          subtitle: '按贡献流水统计',
          emptyText: '暂无排行数据',
          challengeable: false,
          list: Array.isArray(this.sectContributionRank) ? this.sectContributionRank : []
        }
      ].concat(bossPanels);
      return panels.filter(panel => Array.isArray(panel.list));
    }
  },
  watch: {
    activeTab(value) {
      if (value === 'sectTasks') {
        this.loadSectTaskPanel();
      } else if (value === 'sectFavor') {
        this.loadSectFavorPanel();
      } else if (value === 'specialBuilding') {
        this.loadSpecialBuildingPanel();
      }
    }
  },
  methods: {
    switchSectTab(step) {
      const tabs = this.mobileSectTabs;
      const nextIndex = Math.max(0, Math.min(tabs.length - 1, this.mobileSectTabIndex + Number(step || 0)));
      if (tabs[nextIndex]) this.activeTab = tabs[nextIndex].name;
    },
    // 打开宗门界面 - 从父组件调用
    openSect() {
      this.loadClanData();
    },

    // 加载宗门数据
    async loadClanData() {
      try {
        const charaId = this.getCharaId();
        if (!charaId) {
          this.$Message.error('未获取到角色信息');
          return;
        }

        const response = await this.$http.post("/gameSect/sectBoundary/?charaId=" + charaId);

        if (response.data.data === "无宗门") {
          this.currentSect = null;
          this.homeSect = null;
          this.viewingSect = null;
          this.showSectList = true;
          await this.loadSectList();
        } else {
          this.currentSect = response.data.data;
          this.homeSect = response.data.data;
          this.viewingSect = response.data.data;
          this.sectContributionRank = this.currentSect.contributionRankList || [];
          this.sectBossRank = this.normalizeSectBossRankGroups(this.currentSect.sectBossRankList || []);
          this.showSectList = false;
          await this.loadAllSectData();
        }
      } catch (error) {
        console.error('加载宗门数据失败:', error);
        this.$Message.error('加载宗门数据失败');
      }
    },

    // 获取法器类名 - 改为方法
    getTreasureClass(item) {
      if (!item) return '';
      return `treasure-grade-${item.scoreLevel || 1}`;
    },

    // 加载宗门列表
    async loadSectList(autoOpenPreview = true) {
      try {
        const response = await this.$http.post("/gameSect/getSectList");
        this.sectList2 = response.data.data || [];
        this.sectItemList2 = response.data.data || [];
        if (autoOpenPreview && this.sectList2.length) {
          const initialSect = this.selectedSectId
            ? this.sectList2.find(item => item.id === this.selectedSectId)
            : this.sectList2[0];
          if (initialSect) {
            this.openSectPreview(initialSect);
          }
        }
      } catch (error) {
        console.error('加载宗门列表失败:', error);
        this.$Message.error('加载宗门列表失败');
      }
    },

    // 加载所有宗门相关数据
    async loadAllSectData() {
      if (!this.homeSect) return;

      try {
        await Promise.all([
          this.loadDisciples(),
          this.loadTreasure(),
          this.loadTreasureHall(),
          this.loadXinfa(),
          this.loadMessages(),
          this.loadSectContributionSummary(),
          this.loadSectFavorOverview(),
          this.loadSpecialBuildingPanel()
        ]);
      } catch (error) {
        console.error('加载宗门数据失败:', error);
      }
    },

    // 加载弟子列表
    async loadDisciples() {
      this.loadingDisciples = true;
      try {
        const activeSect = this.displaySect || {};
        this.discipleTableData = activeSect.sectDiscipleVoList || [];
        this.discipleTotal = this.discipleTableData.length;
        this.changePage(1);
      } finally {
        this.loadingDisciples = false;
      }
    },

    // 加载宝库
    async loadTreasure() {
      try {
        const charaId = this.getCharaId();
        const params = {
          ...this.treasureSearch,
          charaId,
          page: this.treasureCurrentPage,
          pageSize: this.treasurePageSize
        };

        const response = await this.$http.post("/gameSect/getSectWare", params);
        this.treasureList = response.data.rows || [];
        this.treasureTotal = response.data.records || 0;
      } catch (error) {
        console.error('加载宝库失败:', error);
        this.$Message.error('加载宝库失败');
      }
    },

    // 加载藏宝阁
    async loadTreasureHall() {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post("/gameSect/getSectSyntheticList/?charaId=" + charaId);
        this.treasureHallList = response.data.data || [];
      } catch (error) {
        console.error('加载藏宝阁失败:', error);
        this.$Message.error('加载藏宝阁失败');
      }
    },

    // 加载心法
    async loadXinfa() {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post("/gameSect/getDisXinfaList2/?charaId=" + charaId);

        if (response.data.data) {
          let index = 0;
          for (const key in response.data.data) {
            if (index < 3) {
              this.xinfaLists[index].items = response.data.data[key] || [];
              index++;
            }
          }
        }
      } catch (error) {
        console.error('加载心法失败:', error);
        this.$Message.error('加载心法失败');
      }
    },

    // 加载留言
    async loadMessages() {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.get("/gameSect/querySectBoardList/?charaId=" + charaId);
        this.messageList = response.data.data || [];
      } catch (error) {
        console.error('加载留言失败:', error);
      }
    },

    async loadSectTaskPanel() {
      await Promise.all([
        this.loadSectTasks(),
        this.loadSectContributionSummary(),
        this.loadSectContributionRank(),
        this.loadSectBossRank(),
        this.loadSectMaterials()
      ]);
    },

    async loadSectTasks() {
      this.sectTaskLoading = true;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post("/gameTask/queryTaskList?charaId=" + charaId);
        const taskList = response.data.data || [];
        this.sectTaskList = taskList
          .filter(item => item.taskType === 'sectTask' || item.sectContr != null)
          .filter(item => this.normalizeTaskStatus(item.status) !== 9)
          .map(item => ({
            ...item,
            status: this.normalizeTaskStatus(item.status)
          }));
      } catch (error) {
        console.error('加载宗门任务失败:', error);
        this.$Message.error('加载宗门任务失败');
      } finally {
        this.sectTaskLoading = false;
      }
    },

    async loadSectContributionSummary() {
      if (!this.homeSect) return;
      this.sectContributionLoading = true;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post("/gameSect/queryContributionSummary?charaId=" + charaId);
        const summary = response.data.data || {};
        const sourceMap = {};
        (summary.todayBySource || []).forEach(item => {
          sourceMap[item.sourceType] = item.contribution || 0;
        });
        this.sectContributionSummary = {
          ...summary,
          todayCoinContribution: sourceMap.COIN_DONATE || 0,
          todayMaterialContribution: sourceMap.MATERIAL_DONATE || 0
        };
        this.myContribution = summary.contribution || this.myContribution || 0;
      } catch (error) {
        console.error('加载宗门贡献失败:', error);
      } finally {
        this.sectContributionLoading = false;
      }
    },

    async loadSectContributionRank() {
      if (!this.homeSect) return;
      try {
        const charaId = this.getCharaId();
        const bizDate = this.getTodayText();
        const limit = Math.max(Math.min(this.homeSect.playerNum || 20, 100), 20);
        const response = await this.$http.post(`/gameSect/queryContributionRank?charaId=${charaId}&bizDate=${bizDate}&limit=${limit}`);
        this.sectContributionRank = response.data.data || [];
      } catch (error) {
        console.error('加载宗门贡献排行失败:', error);
        this.sectContributionRank = [];
      }
    },

    async loadSectBossRank() {
      if (!this.homeSect) return;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.get(`/gameLockDemon/sectBossDailyRank?charaId=${charaId}`);
        this.sectBossRank = this.normalizeSectBossRankGroups(response.data.data || []);
      } catch (error) {
        console.error('加载宗门Boss排行失败:', error);
        this.sectBossRank = [];
      }
    },

    async loadSectMaterials() {
      try {
        let materialList = (this.$store && this.$store.state && this.$store.state.materialList) || [];
        if (!materialList.length) {
          const charaId = this.getCharaId();
          const response = await this.$http.post("/gameChara/getCharaMaterial/?charaId=" + charaId);
          materialList = response.data.data || [];
        }
        this.sectMaterialList = materialList.filter(item => item.packItemId && item.itemNum > 0);
      } catch (error) {
        console.error('加载材料背包失败:', error);
        this.sectMaterialList = [];
      }
    },

    async loadSpecialBuildingPanel() {
      const activeSect = this.displaySect || {};
      const targetSectId = activeSect.id || activeSect.sectId;
      const charaId = this.getCharaId();
      if (!charaId || !targetSectId) return;
      this.specialBuildingLoading = true;
      try {
        const overviewResponse = await this.$http.post(`/gameSectSpecialBuilding/queryList?charaId=${charaId}&targetSectId=${targetSectId}`);
        const shopResponse = await this.$http.post(`/gameSectSpecialBuilding/queryMaterialShop?charaId=${charaId}&targetSectId=${targetSectId}`);
        const stateResponse = await this.$http.post(`/gameSectSpecialBuilding/queryPlayerState?charaId=${charaId}`);
        const overview = overviewResponse.data.data || {};
        this.specialBuildingOverview = overview;
        this.specialBuildingList = this.normalizeSpecialBuildingList(overview.buildingList || []);
        this.specialBuildingShopList = this.normalizeSpecialBuildingShopList(shopResponse.data.data || []);
        const buildingIds = this.specialBuildingList.map(item => String(item.buildingId));
        const stateList = stateResponse.data.data || overview.playerStateList || [];
        this.specialBuildingStateList = stateList.filter(item => buildingIds.indexOf(String(item.buildingId)) >= 0);
        await this.loadSectMaterials();
        const hireHall = this.specialBuildingList.find(item => item.buildingCode === 'HIRE_HALL');
        if (hireHall) {
          await this.loadSectHireHallPanel(hireHall);
        }
      } catch (error) {
        console.error('加载特殊建筑失败:', error);
        this.$Message.error(this.getErrorMessage(error, '加载特殊建筑失败'));
      } finally {
        this.specialBuildingLoading = false;
      }
    },

    normalizeSpecialBuildingList(list) {
      return (Array.isArray(list) ? list : []).map(item => {
        const buildingId = item.buildingId || item.id;
        if (buildingId != null && this.specialBuildingDonateNums[buildingId] == null) {
          this.$set(this.specialBuildingDonateNums, buildingId, 1);
        }
        if (buildingId != null && item.buildingCode === 'DUNGEON_FORMATION_HALL' && !this.specialBuildingUseOptions[buildingId]) {
          this.$set(this.specialBuildingUseOptions, buildingId, 'DAMAGE_UP');
        }
        return {
          ...item,
          buildingId,
          currentLevel: item.currentLevel || 1,
          currentProgress: item.currentProgress || 0
        };
      });
    },

    normalizeSpecialBuildingShopList(list) {
      return (Array.isArray(list) ? list : []).map(item => {
        const shopId = item.shopId || item.id;
        if (shopId != null && this.specialBuildingExchangeNums[shopId] == null) {
          this.$set(this.specialBuildingExchangeNums, shopId, 1);
        }
        return {
          ...item,
          shopId
        };
      });
    },

    getSpecialBuildingShop(building) {
      if (!building) return null;
      return (this.specialBuildingShopList || []).find(item =>
        String(item.buildingId) === String(building.buildingId)
      ) || null;
    },

    getSpecialBuildingMaterialName(shop) {
      if (!shop) return '升级材料';
      if (shop.itemName) return shop.itemName;
      const materialNames = {
        910001: '登仙玉阶石',
        910002: '祈天星砂',
        910003: '盟会令',
        910004: '星辉玉',
        910005: '破阵符石',
        910006: '幽影契令',
        910007: '玄经玉简',
        910008: '神锻玄铁',
        910009: '丹霞灵砂'
      };
      return materialNames[Number(shop.itemId)] || '升级材料';
    },

    getSpecialBuildingProgress(building) {
      if (!building || !building.upgradeNeedNum) return 0;
      return Math.min(Math.floor(((building.currentProgress || 0) / building.upgradeNeedNum) * 100), 100);
    },

    async loadSpecialBuildingBusinessGoods(targetSectId, charaId) {
      this.scriptureHallGoodsList = [];
      this.alchemyHouseGoodsList = [];
      const codes = (this.specialBuildingList || []).map(item => item.buildingCode);
      if (codes.indexOf('SCRIPTURE_HALL') >= 0) {
        try {
          const response = await this.$http.post(`/gameSectSpecialBuilding/queryScriptureHallGoods?charaId=${charaId}&targetSectId=${targetSectId}`);
          this.scriptureHallGoodsList = response.data.data || [];
        } catch (error) {
          this.scriptureHallGoodsList = [];
        }
      }
      if (codes.indexOf('ALCHEMY_HOUSE') >= 0) {
        try {
          const response = await this.$http.post(`/gameSectSpecialBuilding/queryAlchemyHouseGoods?charaId=${charaId}&targetSectId=${targetSectId}`);
          this.alchemyHouseGoodsList = response.data.data || [];
        } catch (error) {
          this.alchemyHouseGoodsList = [];
        }
      }
    },

    async openSpecialBuildingBusinessModal(building) {
      if (!building || !this.isSpecialBuildingBusinessBuilding(building)) return;
      if (!this.hasSpecialBuildingActiveState(building)) {
        this.$Message.warning('请先使用建筑');
        return;
      }
      const charaId = this.getCharaId();
      const targetSectId = building.sectId || this.specialBuildingOverview.targetSectId || (this.viewingSect && this.viewingSect.id);
      this.currentSpecialBuildingBusinessBuilding = building;
      this.showSpecialBuildingBusinessModal = true;
      this.specialBuildingActionId = 'load-business-' + building.buildingId;
      try {
        if (building.buildingCode === 'SCRIPTURE_HALL') {
          const response = await this.$http.post(`/gameSectSpecialBuilding/queryScriptureHallGoods?charaId=${charaId}&targetSectId=${targetSectId}`);
          this.scriptureHallGoodsList = response.data.data || [];
        } else if (building.buildingCode === 'ALCHEMY_HOUSE') {
          const response = await this.$http.post(`/gameSectSpecialBuilding/queryAlchemyHouseGoods?charaId=${charaId}&targetSectId=${targetSectId}`);
          this.alchemyHouseGoodsList = response.data.data || [];
        }
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '加载商品失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    getSpecialBuildingBusinessGoods(building) {
      if (!building) return [];
      const source = building.buildingCode === 'SCRIPTURE_HALL'
        ? this.scriptureHallGoodsList
        : (building.buildingCode === 'ALCHEMY_HOUSE' ? this.alchemyHouseGoodsList : []);
      return (source || []).filter(item => String(item.buildingId) === String(building.buildingId));
    },

    getSpecialBuildingBusinessTitle(building) {
      if (!building) return '建筑商品';
      if (building.buildingCode === 'SCRIPTURE_HALL') return '藏经阁商品';
      if (building.buildingCode === 'ALCHEMY_HOUSE') return '丹坊折扣';
      return '建筑商品';
    },

    getSpecialBuildingBusinessGoodsName(goods) {
      if (!goods) return '未命名商品';
      return goods.itemName || goods.formulaName || goods.productItemName || `商品 ${goods.itemId || goods.formulaId || ''}`;
    },

    getSpecialBuildingBusinessGoodsMeta(goods) {
      if (!goods) return '';
      const parts = [];
      if (goods.goodsType) parts.push(goods.goodsType);
      if (goods.discountRate) parts.push(`${Math.round(Number(goods.discountRate) * 10)}折`);
      if (goods.stock != null) parts.push(`库存 ${goods.stock}`);
      return parts.join(' · ');
    },

    async loadSectHireHallPanel(building) {
      if (!building || building.buildingCode !== 'HIRE_HALL') return;
      const charaId = this.getCharaId();
      const targetSectId = building.sectId || this.specialBuildingOverview.targetSectId || (this.viewingSect && this.viewingSect.id);
      if (!charaId || !targetSectId) return;
      try {
        const mapResponse = await this.requestSectHireHall(
          `/gameSectHireHall/mapList?charaId=${charaId}`,
          '加载可选地图失败'
        );
        this.sectHireHallMapList = mapResponse.data.data || [];
        await this.loadSectHireHallOrders();
        if (building.isHomeSect) {
          const snapshotResponse = await this.requestSectHireHall(
            `/gameArmySnapshot/mySnapshots?charaId=${charaId}`,
            '加载我的留影失败'
          );
          this.sectHireHallMySnapshots = snapshotResponse.data.data || [];
          const bountyResponse = await this.requestSectHireHall(
            `/gameSectHireHall/myBounties?charaId=${charaId}&targetSectId=${targetSectId}`,
            '加载我的雇佣留影失败'
          );
          this.sectHireHallMyBounties = bountyResponse.data.data || [];
          if (!this.sectHireHallPublishForm.snapshotId && this.sectHireHallMySnapshots.length) {
            this.sectHireHallPublishForm.snapshotId = this.sectHireHallMySnapshots[0].snapshotId;
          }
        } else {
          const bountyResponse = await this.requestSectHireHall(
            `/gameSectHireHall/bountyList?charaId=${charaId}&targetSectId=${targetSectId}`,
            '加载雇佣留影列表失败'
          );
          this.sectHireHallBountyList = bountyResponse.data.data || [];
          this.initSectHireHallOrderForms();
        }
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '加载雇佣大厅失败'));
      }
    },

    async requestSectHireHall(url, fallbackMessage) {
      try {
        return await this.$http.get(url);
      } catch (error) {
        const message = this.getErrorMessage(error, fallbackMessage);
        throw new Error(`${fallbackMessage}：${message}`);
      }
    },

    async loadSectHireHallOrders() {
      const charaId = this.getCharaId();
      if (!charaId) return;
      try {
        const response = await this.requestSectHireHall(
          `/gameSectHireHall/myOrders?charaId=${charaId}`,
          '加载我的雇佣订单失败'
        );
        this.sectHireHallOrderList = response.data.data || [];
      } catch (error) {
        this.sectHireHallOrderList = [];
        throw error;
      }
    },

    initSectHireHallOrderForms() {
      const defaultMapId = this.sectHireHallMapList.length ? this.sectHireHallMapList[0].mapId : '';
      (this.sectHireHallBountyList || []).forEach(item => {
        if (!this.sectHireHallOrderForms[item.bountyId]) {
          this.$set(this.sectHireHallOrderForms, item.bountyId, {
            mapId: defaultMapId,
            hireHours: 1
          });
        }
      });
    },

    async publishSectHireBounty(building) {
      if (!building || building.buildingCode !== 'HIRE_HALL') return;
      if (!this.sectHireHallPublishForm.snapshotId) {
        this.$Message.warning('请选择留影');
        return;
      }
      const charaId = this.getCharaId();
      const targetSectId = building.sectId || this.specialBuildingOverview.targetSectId || (this.viewingSect && this.viewingSect.id);
      this.specialBuildingActionId = 'hire-publish';
      try {
        const url = `/gameSectHireHall/publish?charaId=${charaId}&targetSectId=${targetSectId}`
          + `&snapshotId=${this.sectHireHallPublishForm.snapshotId}`
          + `&unitCoin=${this.sectHireHallPublishForm.unitCoin || 1}`
          + `&expireHours=${this.sectHireHallPublishForm.expireHours || 72}`;
        const response = await this.$http.post(url);
        this.$Message.success(response.data.msg || '上架成功');
        await this.loadSectHireHallPanel(building);
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '上架失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    async cancelSectHireBounty(bounty) {
      if (!bounty || !bounty.bountyId) return;
      const charaId = this.getCharaId();
      this.specialBuildingActionId = 'hire-cancel-' + bounty.bountyId;
      try {
        const response = await this.$http.post(`/gameSectHireHall/cancel?charaId=${charaId}&bountyId=${bounty.bountyId}`);
        this.$Message.success(response.data.msg || '下架成功');
        const building = this.specialBuildingList.find(item => item.buildingCode === 'HIRE_HALL');
        if (building) await this.loadSectHireHallPanel(building);
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '下架失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    async createSectHireOrder(building, bounty) {
      if (!building || !bounty || !bounty.bountyId) return;
      const form = this.sectHireHallOrderForms[bounty.bountyId] || {};
      if (!form.mapId) {
        this.$Message.warning('请选择挂机地图');
        return;
      }
      const charaId = this.getCharaId();
      const targetSectId = building.sectId || this.specialBuildingOverview.targetSectId || (this.viewingSect && this.viewingSect.id);
      this.specialBuildingActionId = 'hire-order-' + bounty.bountyId;
      try {
        const url = `/gameSectHireHall/createOrder?charaId=${charaId}&targetSectId=${targetSectId}`
          + `&bountyId=${bounty.bountyId}&mapId=${form.mapId}&hireHours=${form.hireHours || 1}`;
        const response = await this.$http.post(url);
        this.$Message.success(response.data.msg || '雇佣成功');
        await this.loadSectHireHallPanel(building);
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '雇佣失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    async settleSectHireOrder(order) {
      if (!order || !order.orderId) return;
      const charaId = this.getCharaId();
      this.specialBuildingActionId = 'hire-settle-' + order.orderId;
      try {
        await this.$http.post(`/gameSectHireHall/settle?charaId=${charaId}&orderId=${order.orderId}`);
        this.$Message.success('结算成功');
        await this.loadSectHireHallOrders();
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '结算失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    async receiveSectHireOrder(order) {
      if (!order || !order.orderId) return;
      const charaId = this.getCharaId();
      this.specialBuildingActionId = 'hire-receive-' + order.orderId;
      try {
        const response = await this.$http.post(`/gameSectHireHall/receive?charaId=${charaId}&orderId=${order.orderId}`);
        this.$Message.success(response.data.msg || '领取成功');
        await this.loadSectHireHallOrders();
        this.$emit('package-updated');
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '领取失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    getSectHireHallMaxHours(building) {
      const effect = this.parseJsonSafe(building && building.effectJson);
      return Number(effect.maxHireHours || 8);
    },

    getSectHireOrderCostText(bounty) {
      if (!bounty || !bounty.bountyId) return '';
      const form = this.sectHireHallOrderForms[bounty.bountyId] || {};
      return `${Number(bounty.unitCoin || 0) * Number(form.hireHours || 1)}灵石`;
    },

    getSectHireOrderStatusText(order) {
      const status = Number(order && order.status);
      if (status === 1) return '进行中';
      if (status === 2) return '可结算';
      if (status === 3) return '待领取';
      if (status === 4) return '已领取';
      if (status === 5) return '已取消';
      return '未知';
    },

    parseJsonSafe(json) {
      if (!json) return {};
      if (typeof json === 'object') return json;
      try {
        return JSON.parse(json);
      } catch (error) {
        return {};
      }
    },

    async exchangeSpecialBuildingBusinessGoods(building, goods) {
      if (!building || !goods || !goods.dailyGoodsId) return;
      const charaId = this.getCharaId();
      const actionId = 'business-' + building.buildingId + '-' + goods.dailyGoodsId;
      const url = building.buildingCode === 'ALCHEMY_HOUSE'
        ? `/gameSectSpecialBuilding/exchangeAlchemyHouseGoods?charaId=${charaId}&dailyGoodsId=${goods.dailyGoodsId}`
        : `/gameSectSpecialBuilding/exchangeScriptureHallGoods?charaId=${charaId}&dailyGoodsId=${goods.dailyGoodsId}`;
      this.specialBuildingActionId = actionId;
      try {
        const response = await this.$http.post(url);
        this.$Message.success(response.data.msg || '操作成功');
        await this.loadSpecialBuildingPanel();
        if (this.showSpecialBuildingBusinessModal) {
          const refreshedBuilding = (this.specialBuildingList || []).find(item => String(item.buildingId) === String(building.buildingId)) || building;
          await this.openSpecialBuildingBusinessModal(refreshedBuilding);
        }
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '操作失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    getSpecialBuildingShopCostText(shop) {
      if (!shop) return '';
      if (shop.isHomeSect) {
        return `${shop.innerCostContribution || 0}贡献/次`;
      }
      return `${shop.outerCostFavor || 0}好感/次`;
    },

    getSpecialBuildingExchangeMax(shop) {
      if (!shop) return 1;
      const dailyRemain = shop.dailyLimit ? Math.max((shop.dailyLimit || 0) - (shop.dailyUsed || 0), 0) : 99;
      const weeklyRemain = shop.weeklyLimit ? Math.max((shop.weeklyLimit || 0) - (shop.weeklyUsed || 0), 0) : 99;
      return Math.max(Math.min(dailyRemain, weeklyRemain, 99), 1);
    },

    isSpecialBuildingShopDisabled(shop) {
      if (!shop) return true;
      if (!shop.isHomeSect && !this.isFavorLevelEnough(shop.favorLevel, shop.unlockFavorLevel)) {
        return true;
      }
      if (shop.dailyLimit && (shop.dailyUsed || 0) >= shop.dailyLimit) {
        return true;
      }
      return !!shop.weeklyLimit && (shop.weeklyUsed || 0) >= shop.weeklyLimit;
    },

    getSpecialBuildingMaterialCount(itemId) {
      if (!itemId) return 0;
      return (this.sectMaterialList || [])
        .filter(item => String(item.itemId) === String(itemId))
        .reduce((total, item) => total + Number(item.itemNum || 0), 0);
    },

    canUseSpecialBuilding(building) {
      if (!building) return false;
      return [
        'ASCEND_PLATFORM',
        'DOUBLE_EXP_PLATFORM',
        'STAR_TOWER',
        'DUNGEON_FORMATION_HALL',
        'SCRIPTURE_HALL',
        'ALCHEMY_HOUSE',
        'FORGE_ROOM'
      ].indexOf(building.buildingCode) >= 0;
    },

    isSpecialBuildingBusinessBuilding(building) {
      return !!building && ['SCRIPTURE_HALL', 'ALCHEMY_HOUSE'].indexOf(building.buildingCode) >= 0;
    },

    hasSpecialBuildingActiveState(building) {
      if (!building) return false;
      return (this.specialBuildingStateList || []).some(state =>
        String(state.buildingId) === String(building.buildingId)
        && state.stateType === 'ACTIVE_BUFF'
      );
    },

    isSpecialBuildingUseDisabled(building) {
      if (!building || !this.canUseSpecialBuilding(building)) return true;
      if (Number(building.useCostConfigured || 0) !== 1) return true;
      return !building.isHomeSect && Number(building.canOuterUse || 0) !== 1;
    },

    getSpecialBuildingUseHint(building) {
      if (!building) return '';
      const map = {
        ASCEND_PLATFORM: '购买后 8 小时内突破成功率提高',
        DOUBLE_EXP_PLATFORM: '本周领取后战斗修为翻倍',
        STAR_TOWER: '本周领取后掉落概率翻倍',
        DUNGEON_FORMATION_HALL: '选择后 4 小时内组队副本生效',
        SCRIPTURE_HALL: '使用后 8 小时内可查看并兑换藏经阁商品',
        ALCHEMY_HOUSE: '使用后 8 小时内可查看并学习丹坊折扣丹方',
        FORGE_ROOM: '使用后 8 小时内锻造折扣生效'
      };
      const effectText = map[building.buildingCode] || '使用后获得对应效果';
      if (!building.isHomeSect && Number(building.canOuterUse || 0) !== 1) {
        return `${effectText}；需要${this.getFavorLevelText(building.outerFavorLevel)}好感`;
      }
      return effectText;
    },

    getSpecialBuildingUseCostText(building) {
      if (!building) return '';
      if (Number(building.useCostConfigured || 0) !== 1) {
        return '使用费用未配置';
      }
      if (building.useCostText) {
        return `本次消耗：${building.useCostText}`;
      }
      const parts = [];
      const coin = Number(building.useCostCoin || 0);
      const contribution = Number(building.useCostContribution || 0);
      if (coin > 0) parts.push(`${coin}灵石`);
      if (contribution > 0) parts.push(`${contribution}贡献`);
      return `本次消耗：${parts.length ? parts.join(' + ') : '无需消耗'}`;
    },

    getSpecialBuildingStateText(state) {
      if (!state) return '';
      if (state.stateType === 'WEEKLY_CLAIM') return '本周已领取';
      if (state.stateType === 'ACTIVE_BUFF') return '效果生效中';
      return '已开启';
    },

    formatSpecialBuildingStateTime(state) {
      if (!state) return '';
      if (state.endTime) {
        return `有效至 ${this.formatTime(state.endTime)}`;
      }
      if (state.bizWeek) {
        return `周期 ${state.bizWeek}`;
      }
      return state.bizDate || '';
    },

    async exchangeSpecialBuildingMaterial(shop) {
      if (!shop || !shop.shopId) return;
      const num = this.specialBuildingExchangeNums[shop.shopId] || 1;
      this.specialBuildingActionId = 'exchange-' + shop.shopId;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSectSpecialBuilding/exchangeUpgradeMaterial?charaId=${charaId}&shopId=${shop.shopId}&num=${num}`);
        this.$Message.success(response.data.msg || '兑换成功');
        await this.loadSpecialBuildingPanel();
        this.$emit('package-updated');
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '兑换失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    async donateSpecialBuildingMaterial(building) {
      if (!building || !building.buildingId || !building.upgradeMaterialItemId) return;
      const itemNum = this.specialBuildingDonateNums[building.buildingId] || 1;
      this.specialBuildingActionId = 'donate-' + building.buildingId;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(
          `/gameSectSpecialBuilding/donateUpgradeMaterial?charaId=${charaId}&buildingId=${building.buildingId}&itemId=${building.upgradeMaterialItemId}&itemNum=${itemNum}`
        );
        this.$Message.success(response.data.msg || '提交成功');
        await this.loadSpecialBuildingPanel();
        this.$emit('package-updated');
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '提交失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    async useSpecialBuilding(building) {
      if (!building || !building.buildingId) return;
      const optionValue = building.buildingCode === 'DUNGEON_FORMATION_HALL'
        ? (this.specialBuildingUseOptions[building.buildingId] || 'DAMAGE_UP')
        : '';
      this.specialBuildingActionId = 'use-' + building.buildingId;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(
          `/gameSectSpecialBuilding/use?charaId=${charaId}&buildingId=${building.buildingId}&useType=BUILDING_USE&optionValue=${optionValue}`
        );
        this.$Message.success(response.data.msg || '使用成功');
        await this.loadSpecialBuildingPanel();
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '使用失败'));
      } finally {
        this.specialBuildingActionId = null;
      }
    },

    isFavorLevelEnough(currentLevel, requireLevel) {
      if (!requireLevel || String(requireLevel).toLowerCase() === 'null') return true;
      return this.getFavorLevelRank(currentLevel) >= this.getFavorLevelRank(requireLevel);
    },

    getFavorLevelRank(level) {
      if (level === 'GUEST') return 3;
      if (level === 'FRIENDLY') return 2;
      return 1;
    },

    async loadSectFavorPanel() {
      if (!this.isViewingSectTaskExchange) return;
      await this.loadSectFavorOverview();
      await Promise.all([
        this.loadFavorTasks(),
        this.loadFavorShop(),
        this.loadSectMaterials()
      ]);
    },

    async loadSectFavorOverview() {
      if (!this.homeSect) return;
      this.favorLoading = true;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSectFavor/queryOverview?charaId=${charaId}`);
        const data = response.data.data || {};
        const list = (data.favorList || data.list || data.sectFavorList || [])
          .filter(item => !this.homeSect || String(item.sectId || item.id) !== String(this.homeSect.id));
        this.sectFavorOverview = data;
        this.sectFavorList = list.map(item => ({
          ...item,
          sectId: item.sectId || item.id,
          sectName: item.sectName || item.name || this.getSectNameById(item.sectId || item.id)
        }));
        if (this.selectedFavorSectId && this.homeSect && String(this.selectedFavorSectId) === String(this.homeSect.id)) {
          this.selectedFavorSectId = null;
        }
        if (this.selectedFavorSectId && !this.sectFavorList.some(item => String(item.sectId) === String(this.selectedFavorSectId))) {
          this.selectedFavorSectId = null;
        }
        if (!this.selectedFavorSectId && this.sectFavorList.length) {
          this.selectedFavorSectId = this.sectFavorList[0].sectId;
        }
      } catch (error) {
        console.error('加载宗门好感失败:', error);
        this.$Message.error('加载宗门好感失败');
      } finally {
        this.favorLoading = false;
      }
    },

    async selectFavorSect(sectId) {
      if (!sectId || String(this.selectedFavorSectId) === String(sectId)) return;
      this.selectedFavorSectId = sectId;
      await Promise.all([
        this.loadFavorTasks(),
        this.loadFavorShop()
      ]);
    },

    async loadFavorTasks() {
      if (!this.selectedFavorSectId) return;
      this.favorTaskLoading = true;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSectFavor/queryTaskList?charaId=${charaId}&sectId=${this.selectedFavorSectId}`);
        const poolTasks = response.data.data || [];
        const acceptedMap = await this.loadFavorAcceptedTaskMap();
        const merged = poolTasks.map(item => {
          const accepted = acceptedMap[item.taskId] || acceptedMap[String(item.taskId)] || {};
          return {
            ...item,
            ...accepted,
            taskId: item.taskId,
            taskName: item.taskName || accepted.taskName || accepted.name,
            taskDesci: item.taskDesci || accepted.taskDesci || accepted.taskDesc,
            favorReward: item.favorReward || accepted.favorReward || 0,
            status: this.normalizeTaskStatus(accepted.status != null ? accepted.status : item.status),
            needRule: accepted.needRule || this.buildFavorNeedRule(item)
          };
        });
        Object.keys(acceptedMap).forEach(taskId => {
          if (!merged.some(item => String(item.taskId) === String(taskId))) {
            const accepted = acceptedMap[taskId];
            merged.push({
              ...accepted,
              favorReward: accepted.favorReward || 0,
              status: this.normalizeTaskStatus(accepted.status),
              needRule: accepted.needRule || []
            });
          }
        });
        this.favorTaskList = merged.filter(item =>
          this.normalizeTaskStatus(item.status) !== 9 && Number(item.favorReward || 0) > 0
        );
      } catch (error) {
        console.error('加载好感委托失败:', error);
        this.$Message.error('加载好感委托失败');
      } finally {
        this.favorTaskLoading = false;
      }
    },

    async loadFavorAcceptedTaskMap() {
      const charaId = this.getCharaId();
      const response = await this.$http.post("/gameTask/queryTaskList?charaId=" + charaId);
      const taskList = response.data.data || [];
      const result = {};
      taskList
        .filter(item => item.taskType === 'sectFavorTask' && this.normalizeTaskStatus(item.status) !== 9)
        .forEach(item => {
          result[item.taskId] = {
            ...item,
            status: this.normalizeTaskStatus(item.status)
          };
        });
      return result;
    },

    async refreshFavorTasks() {
      if (!this.selectedFavorSectId) return;
      this.favorActionId = 'refresh';
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSectFavor/refreshTasks?charaId=${charaId}&sectId=${this.selectedFavorSectId}`);
        if (response.data.msg) {
          this.$Message.success(response.data.msg);
        }
        await this.loadFavorTasks();
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '重置委托失败');
      } finally {
        this.favorActionId = null;
      }
    },

    async acceptFavorTask(task) {
      this.favorActionId = task.taskId;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSectFavor/acceptTask?charaId=${charaId}&taskId=${task.taskId}`);
        this.$Message.success(response.data.msg);
        await this.loadFavorTasks();
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '接取委托失败');
      } finally {
        this.favorActionId = null;
      }
    },

    async refreshFavorTask(task) {
      this.favorActionId = task.taskId;
      try {
        const charaId = this.getCharaId();
        await this.$http.post(`/gameTask/refreshTask?charaId=${charaId}&taskId=${task.taskId}`);
        await this.loadFavorTasks();
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '刷新委托失败');
      } finally {
        this.favorActionId = null;
      }
    },

    async claimFavorTask(task) {
      this.favorActionId = task.taskId;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameTask/claimRewards?charaId=${charaId}&taskId=${task.taskId}&rewardId=0`);
        this.$Message.success(response.data.msg);
        await this.loadSectFavorPanel();
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '领取好感失败');
      } finally {
        this.favorActionId = null;
      }
    },

    async loadFavorShop() {
      if (!this.selectedFavorSectId) return;
      this.favorShopLoading = true;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSectFavor/queryShop?charaId=${charaId}&sectId=${this.selectedFavorSectId}`);
        this.favorShopList = response.data.data || [];
      } catch (error) {
        console.error('加载好感兑换失败:', error);
        this.$Message.error('加载好感兑换失败');
      } finally {
        this.favorShopLoading = false;
      }
    },

    async exchangeFavorShop(item) {
      this.favorExchangeId = item.shopId;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSectFavor/exchange?charaId=${charaId}&shopId=${item.shopId}&num=1`);
        this.$Message.success(response.data.msg);
        await Promise.all([
          this.loadSectFavorOverview(),
          this.loadFavorShop()
        ]);
        this.$emit('package-updated');
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '兑换失败');
      } finally {
        this.favorExchangeId = null;
      }
    },

    buildFavorNeedRule(task) {
      if (!task) return [];
      return [{
        dtlType: task.needType,
        dtlNeedId: task.needId,
        dtlNeedName: task.needName,
        dtlNeedNum: task.needNum || 0,
        dtlSubNum: 0
      }];
    },

    async receiveSectTask(task) {
      this.sectTaskActionId = task.taskId;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameTask/pickUpTask?charaId=${charaId}&taskId=${task.taskId}`);
        this.$Message.success(response.data.msg);
        await this.loadSectTaskPanel();
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '接取任务失败');
      } finally {
        this.sectTaskActionId = null;
      }
    },

    async refreshSectTask(task) {
      this.sectTaskActionId = task.taskId;
      try {
        const charaId = this.getCharaId();
        await this.$http.post(`/gameTask/refreshTask?charaId=${charaId}&taskId=${task.taskId}`);
        await this.loadSectTasks();
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '刷新任务失败');
      } finally {
        this.sectTaskActionId = null;
      }
    },

    async claimSectTask(task) {
      this.sectTaskActionId = task.taskId;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameTask/claimRewards?charaId=${charaId}&taskId=${task.taskId}&rewardId=0`);
        this.$Message.success(response.data.msg);
        await this.loadSectTaskPanel();
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '领取任务奖励失败');
      } finally {
        this.sectTaskActionId = null;
      }
    },

    async donateSectCoin() {
      if (!this.sectCoinDonateNum || this.sectCoinDonateNum < 100) {
        this.$Message.warning('灵石捐献至少 100');
        return;
      }
      this.sectDonateLoading = true;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSect/donateSectCoin?charaId=${charaId}&coinNum=${this.sectCoinDonateNum}`);
        this.$Message.success(response.data.msg);
        await this.loadSectTaskPanel();
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '灵石捐献失败');
      } finally {
        this.sectDonateLoading = false;
      }
    },

    async donateSectMaterial() {
      if (!this.sectDonateMaterialPackId) {
        this.$Message.warning('请选择捐献材料');
        return;
      }
      if (!this.sectDonateMaterialNum || this.sectDonateMaterialNum < 10) {
        this.$Message.warning('材料捐献至少 10 个');
        return;
      }
      this.sectDonateLoading = true;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSect/donateSectMaterial?charaId=${charaId}&packId=${this.sectDonateMaterialPackId}&packNum=${this.sectDonateMaterialNum}`);
        this.$Message.success(response.data.msg);
        this.sectDonateMaterialPackId = '';
        this.sectDonateMaterialNum = 10;
        await this.loadSectTaskPanel();
        this.$emit('package-updated');
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '材料捐献失败');
      } finally {
        this.sectDonateLoading = false;
      }
    },

    openSectMatSubmit(dtl) {
      this.currentSectTaskNeed = dtl;
      this.sectSubmitMaterialPackId = '';
      const remain = Math.max((dtl.dtlNeedNum || 0) - (dtl.dtlSubNum || 0), 1);
      this.sectSubmitMaterialNum = remain;
      this.sectSubmitMaterialList = this.sectMaterialList.filter(item => item.itemId == dtl.dtlNeedId);
      if (this.sectSubmitMaterialList.length === 0) {
        this.$Message.warning('背包中没有符合要求的材料');
        return;
      }
      this.showSectMatSubmitModal = true;
    },

    async submitSectTaskMaterial() {
      if (!this.currentSectTaskNeed || !this.sectSubmitMaterialPackId) {
        this.$Message.warning('请选择提交材料');
        return;
      }
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(
          `/gameTask/submitMatTask?charaId=${charaId}&taskId=${this.currentSectTaskNeed.dtlId}&packId=${this.sectSubmitMaterialPackId}&packNum=${this.sectSubmitMaterialNum}`
        );
        this.$Message.success(response.data.msg);
        this.showSectMatSubmitModal = false;
        if (this.activeTab === 'sectFavor') {
          await this.loadFavorTasks();
        } else {
          await this.loadSectTaskPanel();
        }
        this.$emit('package-updated');
      } catch (error) {
        this.$Message.error(error.data && error.data.msg ? error.data.msg : '提交材料失败');
      }
    },

    // 加入宗门
    async joinSect(sect) {
      this.joiningSectId = sect.id;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSect/playerJoinSect/?charaId=${charaId}&sectId=${sect.id}`);

        this.$Message.success(response.data.msg);
        this.showSectPreview = false;
        this.showSectList = false;
        await this.loadClanData();

        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(error.data.msg || '加入宗门失败');
      } finally {
        this.joiningSectId = null;
      }
    },

    getSectPosition(sect, index) {
      const mapped = this.sectMapPositions[sect.name] || this.sectMapPositions[sect.id];
      if (mapped) return mapped;

      const fallbackPositions = [
        { top: "66%", left: "14%" },
        { top: "52%", left: "24%" },
        { top: "35%", left: "32%" },
        { top: "76%", left: "34%" },
        { top: "82%", left: "50%" },
        { top: "78%", left: "64%" },
        { top: "68%", left: "78%" },
        { top: "42%", left: "72%" },
        { top: "20%", left: "82%" },
        { top: "20%", left: "50%" }
      ];

      return fallbackPositions[index % fallbackPositions.length];
    },

    getSectMapStyle() {
      return {
        backgroundImage: `linear-gradient(180deg, rgba(5, 10, 18, 0.06), rgba(5, 10, 18, 0.4)), url(${this.sectWorldMap})`
      };
    },

    getSectMarkerStyle(sect) {
      const position = sect.mapPosition || {};
      return {
        top: position.top || "50%",
        left: position.left || "50%"
      };
    },

    openSectPreview(sect) {
      this.selectedSectId = sect.id;
      this.selectedMapSect = sect;
      this.showSectPreview = true;
    },

    getSectRequirementText(sect) {
      if (!sect) return '暂无要求';
      if (sect.keepName && sect.keepNum != null) {
        return sect.keepName + ' × ' + sect.keepNum;
      }
      return '暂无要求';
    },

    getSectPrimaryActionText(sect) {
      if (!sect) return '查看';
      if (this.homeSect && this.homeSect.id === sect.id) {
        return '进入宗门';
      }
      if (this.homeSect && this.homeSect.id !== sect.id) {
        return '查看宗门';
      }
      return '加入宗门';
    },

    handleSectPrimaryAction(sect) {
      if (!sect) return;

      if (this.homeSect && this.homeSect.id === sect.id) {
        this.showSectPreview = false;
        this.showSectList = false;
        this.viewingSect = this.homeSect;
        this.loadDisciples();
        this.activeTab = 'info';
        return;
      }

      if (this.homeSect && this.homeSect.id !== sect.id) {
        this.showSectPreview = false;
        this.viewingSect = sect;
        this.showSectList = false;
        this.activeTab = 'info';
        this.loadDisciples();
        return;
      }

      this.viewingSect = sect;
      this.joinSect(sect);
    },

    async showWorldMap() {
      this.showSectList = true;
      this.showSectPreview = false;
      this.selectedSectId = this.displaySect ? this.displaySect.id : this.selectedSectId;
      if (!this.sectList2.length) {
        await this.loadSectList(false);
      }
    },

    returnToHomeSect() {
      if (!this.homeSect) return;
      this.viewingSect = this.homeSect;
      this.showSectList = false;
      this.activeTab = 'info';
      this.loadDisciples();
    },

    // 弟子搜索
    searchDisciple() {
      this.discipleCurrentPage = 1;
    },

    // 分页
    changePage(page) {
      this.discipleCurrentPage = page;
    },

    // 切磋
    async duel(discipleId) {
      this.duelingId = discipleId;
      try {
        this.$emit('duel', discipleId);
      } finally {
        this.duelingId = null;
      }
    },
    // 搜索宝库
    searchTreasure() {
      this.treasureCurrentPage = 1;
      this.loadTreasure();
    },

    // 宝库分页
    changeTreasurePage(page) {
      this.treasureCurrentPage = page;
      this.loadTreasure();
    },
    getStarCount(starString) {
      if (!starString) return 0;

      // 如果是数字，直接返回
      if (typeof starString === 'number') {
        return Math.max(1, Math.min(starString, 7)); // 限制在1-7之间
      }

      // 如果是字符串，计算★的数量
      if (typeof starString === 'string') {
        // 方法1: 使用正则表达式
        const match = starString.match(/★/g);
        return match ? match.length : 0;

        // 方法2: 使用split
        // return starString.split('★').length - 1;

        // 方法3: 使用replace
        // return starString.length - starString.replace(/★/g, '').length;
      }

      // 如果是其他类型，尝试转换
      const num = Number(starString);
      return isNaN(num) ? 0 : num;
    },
    // 显示装备详情
    showTreasureDetail(item) {
      this.selectedItem = item;
      this.showItemDetail = true;
    },

    // 兑换法器
    exchangeTreasure(item, index) {
      this.exchangingItem = item;
      this.exchangingIndex = index;
      this.showExchangeConfirm = true;
    },

    // 确认兑换
    async confirmExchange() {
      if (!this.exchangingItem) return;

      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(
          `/gameSect/playersExchangeWarehouse?charaId=${charaId}&wareId=${this.exchangingItem.packItemId}&itemId=${this.exchangingItem.itemId || ''}`
        );

        this.$Message.success(response.data.msg);

        // 移除已兑换的法器
        this.treasureList.splice(this.exchangingIndex, 1);
        this.treasureTotal--;

        // 通知父组件更新背包
        this.$emit('package-updated');
        await Promise.all([this.loadXinfa(), this.loadSectContributionSummary()]);
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '兑换失败'));
      } finally {
        this.exchangingItem = null;
        this.exchangingIndex = null;
        this.showExchangeConfirm = false;
      }
    },

    // 藏宝阁兑换
    async exchangeTreasureHall(item, index) {
      this.exchangingHallIndex = index;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(
          `/gameSect/breakThroughTheSect?charaId=${charaId}&syntheticId=${item.syntheticId}&syntheticNum=1`
        );

        this.$Message.success(response.data.msg);
        await this.loadTreasureHall();
        await Promise.all([this.loadXinfa(), this.loadSectContributionSummary()]);
        this.$emit('package-updated');
      } catch (error) {
        this.$Message.error(this.getErrorMessage(error, '兑换失败'));
      } finally {
        this.exchangingHallIndex = null;
      }
    },

    // 捐献装备
    async addEquit() {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`gameChara/getCharaPackage?charaId=${charaId}`);

        this.donateableItems = (response.data.data || []).filter(item =>
          item.color == 6 && item.enhanLevel == 0 && item.scoreLevel != null
        );

        if (this.donateableItems.length === 0) {
          this.$Message.info('暂无符合条件的装备可捐献');
          return;
        }

        this.showDonateModal = true;
      } catch (error) {
        this.$Message.error('获取装备列表失败');
      }
    },

    // 确认捐献
    async confirmDonate() {
      if (!this.selectedDonateItem) {
        this.$Message.warning('请选择要捐献的装备');
        return;
      }

      this.loadingDonate = true;
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(
          `/gameSect/playersConsignWare?charaId=${charaId}&packId=${this.selectedDonateItem}`
        );

        this.$Message.success(response.data.msg);
        this.$emit('package-updated');
        await this.loadSectContributionSummary();
        this.showDonateModal = false;
        this.selectedDonateItem = '';
      } catch (error) {
        this.$Message.error(error.data.msg || '捐献失败');
      } finally {
        this.loadingDonate = false;
      }
    },

    // 心法操作
    async xiulian(item, listNum, status) {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(
          `/gameSect/updateDisXinfa?charaId=${charaId}&xinfaId=${item.id}&status=${status}`
        );

        this.$Message.success(response.data.msg);
        await this.loadXinfa();
      } catch (error) {
        this.$Message.error(error.data.msg || '操作失败');
      }
    },

    // 遗忘心法
    async forgetXinfa(item, listNum) {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(
          `/gameSect/removeDisXinfa?charaId=${charaId}&xinfaId=${item.id}`
        );

        this.$Message.success(response.data.msg);
        await this.loadXinfa();
      } catch (error) {
        this.$Message.error(error.data.msg || '操作失败');
      }
    },

    // 弟子晋升
    async disiplePromotion() {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSect/disiplePromotion/?charaId=${charaId}`);
        this.$Message.success(response.data.msg);
        await this.loadClanData();
        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(error.data.msg || '晋升失败');
      }
    },

    // 报名大比
    async sectRegistCompe() {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameLockDemon/sectRegistCompe/?charaId=${charaId}`);
        this.$Message.success(response.data.msg);
      } catch (error) {
        this.$Message.error(error.data.msg || '报名失败');
      }
    },

    // 打开大比赛事页（海选/瑞士轮/淘汰赛对阵图，弹窗外壳在 headers2）
    openCompePage() {
      this.$emit('open-sect-compe');
    },

    // 退出宗门
    showExitConfirm() {
      this.showExitConfirmModal = true;
    },

    async confirmExit() {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(`/gameSect/exitSect/?charaId=${charaId}`);

        this.$Message.success(response.data.msg);
        // 退出后显示宗门列表
        this.showSectList = true;
        this.currentSect = null;
        this.homeSect = null;
        this.viewingSect = null;
        await this.loadSectList();

        this.$emit('user-updated');
      } catch (error) {
        this.$Message.error(error.data.msg || '退出失败');
      } finally {
        this.showExitConfirmModal = false;
      }
    },

    // 留言操作
    showAddMessage() {
      this.messageContent = '';
      this.showMessageModal = true;
    },

    async confirmAddMessage() {
      if (!this.messageContent.trim()) {
        this.$Message.warning('请输入留言内容');
        return;
      }

      try {
        const charaId = this.getCharaId();
        const response = await this.$http.post(
          `/gameSect/addSectBoard?charaId=${charaId}&msg=${encodeURIComponent(this.messageContent)}`
        );

        this.$Message.success(response.data.msg);
        await this.loadMessages();
        this.showMessageModal = false;
      } catch (error) {
        this.$Message.error(error.data.msg || '留言失败');
      }
    },

    // 工具方法
    getCharaId() {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; charaId=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return '';
    },

    getErrorMessage(error, fallback = '操作失败') {
      return (error && error.data && error.data.msg)
        || (error && error.response && error.response.data && error.response.data.msg)
        || fallback;
    },

    getItemType(kind) {
      const types = {
        1: '武器', 2: '玄端', 3: '头冠', 4: '项链',
        7: '戒指', 9: '绶带', 10: '鞜履'
      };
      return types[kind] || '未知';
    },

    getGradeName(level) {
      const grades = ['普通', '稀有', '灵级', '王级', '域级', '圣级', '神级'];
      return grades[level - 1] || '未知';
    },

    getItemColor(color) {
      const colors = {
        1: "#000", 2: "#c5c52f", 3: "#049c04",
        4: "#005aff", 5: "#ff00e0", 6: "#ff0000"
      };
      return colors[color] || "#ff00c3e0";
    },

    getItemAttributes(item) {
      const attributes = [];

      const attrMap = [
        { key: 'life', label: '生命值', suffix: '', randomKey: 'lifeRandom', strengKey: 'strengLife' },
        { key: 'mana', label: '真气值', suffix: '', randomKey: 'manaRandom', strengKey: 'strengMana' },
        { key: 'attack', label: '攻击力', suffix: '', randomKey: 'attackRandom', strengKey: 'strengAttack' },
        { key: 'magAttack', label: '法术攻击', suffix: '', randomKey: 'magAttackRandom', strengKey: 'strengMagAttack' },
        { key: 'defense', label: '物理防御', suffix: '', randomKey: 'defenseRandom', strengKey: 'strengDefense' },
        { key: 'magicDefense', label: '法术防御', suffix: '', randomKey: 'magicDefenseRandom', strengKey: 'strengMagicDefense' },
        { key: 'hitRate', label: '命中率', suffix: '%', randomKey: 'hitRateRandom', isPercent: true },
        { key: 'evade', label: '闪避率', suffix: '%', randomKey: 'evadeRandom', isPercent: true },
        { key: 'critical', label: '暴击率', suffix: '%', randomKey: 'criticalRandom', isPercent: true },
        { key: 'criDamage', label: '暴击伤害', suffix: '%', randomKey: 'criDamageRandom', isPercent: true },

        { key: 'armor', label: '破甲', suffix: '%', isPercent: true },
        { key: 'combo', label: '连击', suffix: '%',  isPercent: true },
        { key: 'counter', label: '反击', suffix: '%',  isPercent: true },
        { key: 'speed', label: '行动速度', suffix: '', randomKey: 'speedRandom' },
        { key: 'physique', label: '根骨', suffix: '', randomKey: 'physiqueRandom', strengKey: 'strengPhysique' },
        { key: 'dexterous', label: '力道', suffix: '', randomKey: 'dexterousRandom', strengKey: 'strengDexterous' },
        { key: 'spirit', label: '灵力', suffix: '', randomKey: 'spiritRandom', strengKey: 'strengSpirit' }
      ];

      attrMap.forEach(attr => {
        if (item[attr.key]) {
          let value = item[attr.key];
          if (attr.isPercent) {
            value = (value * 100).toFixed(2);
          }

          let text = `${value}${attr.suffix}`;
          if (item[attr.randomKey]) {
            text += ` (${item[attr.randomKey]})`;
          }
          if (item[attr.strengKey]) {
            text += ` (${item[attr.strengKey]})`;
          }

          attributes.push({ label: attr.label, value: text });
        }
      });

      return attributes;
    },

    normalizeTaskStatus(status) {
      return status == null ? 0 : Number(status);
    },

    getSectTaskStatusText(status) {
      const statusValue = this.normalizeTaskStatus(status);
      const textMap = {
        0: '未接取',
        1: '进行中',
        2: '待领取',
        3: '已完成',
        9: '已完成'
      };
      return textMap[statusValue] || '未知';
    },

    getSectTaskStatusColor(status) {
      const statusValue = this.normalizeTaskStatus(status);
      const colorMap = {
        0: 'default',
        1: 'primary',
        2: 'success',
        3: 'green',
        9: 'green'
      };
      return colorMap[statusValue] || 'default';
    },

    getSectTaskRequirementText(type) {
      const textMap = {
        map: '探索',
        mat: '提交',
        monster: '讨伐',
        note: '完成'
      };
      return textMap[type] || '完成';
    },

    isSectMaterialRequirement(dtl) {
      return dtl && dtl.dtlType === 'mat';
    },

    isSectMapRequirement(dtl) {
      return dtl && dtl.dtlType === 'map' && dtl.dtlNeedId;
    },

    isSectMonsterRequirement(dtl) {
      return dtl && dtl.dtlType === 'monster' && dtl.dtlNeedId;
    },

    openSectTaskTarget(dtl) {
      if (!dtl) return;
      if (dtl.dtlType === 'map') {
        this.$Message.info(`请前往普通地图【${dtl.dtlNeedName || dtl.dtlNeedId}】探索，累计次数会自动计入任务进度`);
        return;
      }
      if (dtl.dtlType === 'monster') {
        this.$Message.info(`请前往对应普通地图讨伐怪物【${dtl.dtlNeedName || dtl.dtlNeedId}】，累计击败次数会自动计入任务进度`);
      }
    },

    getSectRankValue(panel, row) {
      if (!panel || !row) return 0;
      if (panel.key === 'sectBoss') {
        return row.totalDamage || row.contribution || 0;
      }
      if (panel.key && String(panel.key).indexOf('sectBoss-') === 0) {
        return row.totalDamage || row.contribution || 0;
      }
      return row.contribution || 0;
    },

    async challengeSectBossFromRank(row) {
      try {
        const charaId = this.getCharaId();
        const response = await this.$http.get(`/gameLockDemon/queryMapList?charaId=${charaId}`);
        const mapList = response.data.data || [];
        const targetMap = this.resolveSectBossTargetMap(mapList, row);
        if (!targetMap) {
          this.$Message.warning('未找到当前宗门Boss入口');
          return;
        }
        this.$emit('open-sect-boss-map', {
          mapId: targetMap.mapId,
          mapName: targetMap.mapName,
          autoStart: true
        });
      } catch (error) {
        console.error('跳转宗门Boss挑战失败:', error);
        this.$Message.error('跳转宗门Boss挑战失败');
      }
    },

    normalizeSectBossRankGroups(raw) {
      if (!Array.isArray(raw) || raw.length === 0) {
        return [];
      }
      const first = raw[0] || {};
      if (Array.isArray(first.rankList)) {
        return raw;
      }
      const grouped = {};
      raw.forEach(item => {
        if (!item) return;
        const key = String(item.mapId || item.bossName || 'unknown');
        if (!grouped[key]) {
          grouped[key] = {
            mapId: item.mapId,
            mapName: item.mapName,
            bossName: item.bossName,
            minLv: item.minLv,
            maxLv: item.maxLv,
            title: this.resolveSectBossPanelTitle(item),
            subtitle: '按今日累计伤害统计',
            rankList: []
          };
        }
        grouped[key].rankList.push(item);
      });
      return Object.values(grouped);
    },

    resolveSectBossPanelTitle(group) {
      if (group && group.maxLv) {
        return `${group.maxLv}级 Boss 排行`;
      }
      if (group && group.bossName) {
        return `${group.bossName} 排行`;
      }
      return '宗门Boss排行';
    },

    resolveSectBossTargetMap(mapList, row) {
      const list = Array.isArray(mapList) ? mapList : [];
      if (!list.length) return null;
      const rowMapId = row && (row.mapId || row.monId);
      const rowMapName = row && (row.mapName || row.bossName || row.monName);
      return list.find(item => String(item.mapId) === String(rowMapId))
        || list.find(item => item.mapName === rowMapName)
        || list.find(item => item.mapName === `[宗门Boss] ${rowMapName}`)
        || list.find(item => typeof item.mapName === 'string' && item.mapName.indexOf('[宗门Boss]') === 0)
        || null;
    },

    getSectSubmitMaterialMax() {
      if (!this.sectSubmitMaterialPackId) return 1;
      const material = this.sectSubmitMaterialList.find(item => item.packItemId === this.sectSubmitMaterialPackId);
      if (!material) return 1;
      const remain = this.currentSectTaskNeed
        ? Math.max((this.currentSectTaskNeed.dtlNeedNum || 0) - (this.currentSectTaskNeed.dtlSubNum || 0), 1)
        : 1;
      return Math.max(Math.min(material.itemNum || 1, remain), 1);
    },

    getSectNameById(sectId) {
      const sect = (this.sectList2 || []).find(item => String(item.id) === String(sectId));
      return sect ? sect.name : `宗门${sectId || ''}`;
    },

    getFavorLevelText(level) {
      const map = {
        COLD: '冷淡',
        FRIENDLY: '友善',
        GUEST: '贵客'
      };
      return map[level] || level || '冷淡';
    },

    getFavorNextNeed(sect) {
      const total = sect ? (sect.totalFavor || sect.favorValue || 0) : 0;
      if (total < 100) return 100;
      if (total < 500) return 500;
      return 500;
    },

    getFavorProgressPercent(sect) {
      const nextNeed = this.getFavorNextNeed(sect);
      if (!nextNeed) return 0;
      const total = sect ? (sect.totalFavor || sect.favorValue || 0) : 0;
      return Math.min(Math.floor((total / nextNeed) * 100), 100);
    },

    getFavorTaskNeedRules(task) {
      if (task && Array.isArray(task.needRule) && task.needRule.length) {
        return task.needRule;
      }
      return this.buildFavorNeedRule(task);
    },

    getFavorTaskStatusText(status) {
      const normalized = this.normalizeTaskStatus(status);
      if (normalized === 0) return '可接取';
      if (normalized === 1) return '进行中';
      if (normalized === 2) return '可领取';
      if (normalized === 3 || normalized === 9) return '已完成';
      return '未知';
    },

    getFavorTaskStatusColor(status) {
      const normalized = this.normalizeTaskStatus(status);
      if (normalized === 0) return 'blue';
      if (normalized === 1) return 'orange';
      if (normalized === 2) return 'green';
      return 'default';
    },

    getFavorShopLevelText(level) {
      return `${this.getFavorLevelText(level)}解锁`;
    },

    getFavorShopLockedText(item) {
      if (!item) return '';
      if (!item.unlocked) {
        return `需要${this.getFavorShopLevelText(item.unlockLevel)}`;
      }
      if (item.weeklyLimit && (item.weeklyUsed || 0) >= item.weeklyLimit) {
        return '本周兑换次数已满';
      }
      return '';
    },

    isFavorShopExchangeDisabled(item) {
      if (!item || !item.unlocked) return true;
      return !!item.weeklyLimit && (item.weeklyUsed || 0) >= item.weeklyLimit;
    },

    getTodayText() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    formatTime(time) {
      if (!time) return '';
      return new Date(time).toLocaleString();
    },

    showMessageAction(message) {
      // 处理点化操作
      console.log('点化留言:', message);
      this.$Message.info('点化功能暂未实现');
    },
    showMessageAction2(message) {
      try {
        this.$emit('duel2', message.recordId);
      } finally {
        this.duelingId = null;
      }
    },

    cleanup() {
      this.activeTab = 'info';
      this.discipleSearch = '';
      this.selectedSectId = null;
      this.selectedMapSect = null;
      this.currentSect = null;
      this.homeSect = null;
      this.viewingSect = null;
      this.showSectPreview = false;
      this.treasureSearch = {
        name: '',
        element: '',
        level: '',
        sectId: null
      };
      this.specialBuildingOverview = {};
      this.specialBuildingList = [];
      this.specialBuildingShopList = [];
      this.specialBuildingStateList = [];
      this.scriptureHallGoodsList = [];
      this.alchemyHouseGoodsList = [];
      this.showSpecialBuildingBusinessModal = false;
      this.currentSpecialBuildingBusinessBuilding = null;
      this.sectHireHallMySnapshots = [];
      this.sectHireHallMyBounties = [];
      this.sectHireHallBountyList = [];
      this.sectHireHallMapList = [];
      this.sectHireHallOrderList = [];
      this.sectHireHallPublishForm = {
        snapshotId: '',
        unitCoin: 100,
        expireHours: 72
      };
      this.sectHireHallOrderForms = {};
      this.specialBuildingActionId = null;
    }
  }
}
</script>

<style scoped>
/* 基础样式 */

.sect-card,
.treasure-item,
.xinfa-item,
.message-item {
  animation: fadeIn 0.3s ease-out;
}
/* 加载中状态 */
.loading-state {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 调整主界面容器 */
.main-clan-content {
  display: flex;
  flex-direction: column;
  height: min(calc(100vh - 120px), 760px);
  min-height: 0;
  border-radius: 22px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e9dcc5;
  box-shadow: 0 16px 36px rgba(34, 24, 12, 0.08);
}

.sect-detail-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px 10px;
  background: linear-gradient(180deg, #fffaf1, #ffffff);
  border-bottom: 1px solid #f0e5d4;
}

.sect-detail-toolbar__title h3 {
  margin: 4px 0 0;
  font-size: 20px;
  color: #2d2417;
}

.sect-detail-toolbar__eyebrow {
  color: #9b6b22;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.sect-detail-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.clan-modal-wrapper {
  font-family: 'Microsoft YaHei', 'Segoe UI', sans-serif;
  color: var(--text-primary, #17233d);
}

/* 宗门地图样式 */
.sect-map-shell {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 22px;
  background: #ffffff;
  border: 1px solid #eadfcf;
  box-shadow: 0 14px 32px rgba(42, 28, 10, 0.08);
}

.sect-map-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 260px;
  gap: 14px;
}

.sect-map-hero__copy,
.sect-map-hero__quote {
  border-radius: 18px;
  padding: 18px 20px;
  border: 1px solid #eadfcf;
  background: #ffffff;
}

.sect-map-hero__eyebrow {
  margin-bottom: 10px;
  color: #9b6b22;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.2em;
}

.sect-map-hero__quote {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(135deg, #fffaf2, #fff);
  color: #6f5833;
}

.sect-map-hero__quote::after {
  content: "";
  position: absolute;
  right: -30px;
  bottom: -30px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(239, 201, 128, 0.24), transparent 70%);
}

.sect-map-hero__quote-label {
  margin-bottom: 10px;
  color: #b18749;
  font-size: 12px;
  letter-spacing: 0.18em;
}

.sect-map-hero__quote p {
  position: relative;
  z-index: 1;
  margin: 0;
  line-height: 1.9;
  font-size: 13px;
}

.sect-map-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.sect-map-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary, #17233d);
  letter-spacing: 0.04em;
}

.sect-map-subtitle {
  margin-top: 6px;
  color: var(--text-secondary, #808695);
  font-size: 13px;
  line-height: 1.6;
}

.sect-map-legend {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(11, 20, 34, 0.06);
  color: var(--text-secondary, #808695);
  font-size: 12px;
  white-space: nowrap;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.18);
}

.legend-dot--idle {
  background: #d6a65a;
}

.legend-dot--active {
  background: #52c41a;
}

.sect-world-map {
  position: relative;
  min-height: 680px;
  overflow: hidden;
  border-radius: 22px;
  border: 1px solid rgba(178, 144, 87, 0.35);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow:
    inset 0 0 0 1px rgba(255, 255, 255, 0.08),
    inset 0 0 120px rgba(5, 9, 16, 0.18),
    0 18px 40px rgba(7, 13, 22, 0.18);
}

.sect-world-map__backdrop {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 30%, rgba(102, 178, 255, 0.18), transparent 34%),
    radial-gradient(circle at 75% 75%, rgba(255, 98, 0, 0.16), transparent 28%),
    radial-gradient(circle at 50% 50%, rgba(255, 226, 160, 0.08), transparent 38%);
}

.sect-world-map__overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.05), transparent 24%, rgba(0, 0, 0, 0.25) 100%),
    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 0, rgba(255, 255, 255, 0.04) 1px, transparent 1px),
    linear-gradient(rgba(255, 255, 255, 0.04) 0, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: auto, 56px 56px, 56px 56px;
  pointer-events: none;
}

.sect-marker {
  position: absolute;
  z-index: 2;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.sect-marker__pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 82px;
  height: 82px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(245, 200, 120, 0.34) 0%, rgba(245, 200, 120, 0) 70%);
  animation: sectMarkerPulse 2.6s ease-in-out infinite;
}

.sect-marker__core {
  position: relative;
  z-index: 1;
  width: 58px;
  height: 58px;
  padding: 4px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 239, 199, 0.95), rgba(187, 137, 58, 0.96));
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.sect-marker__icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid rgba(20, 17, 11, 0.72);
  background: rgba(255, 255, 255, 0.96);
}

.sect-marker__label {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transform: translateX(-50%);
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(10, 16, 24, 0.84);
  border: 1px solid rgba(246, 212, 154, 0.4);
  color: #f7e6b5;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.24);
  white-space: nowrap;
}

.sect-marker__name {
  font-size: 13px;
  font-weight: 700;
}

.sect-marker__meta {
  color: rgba(247, 230, 181, 0.72);
  font-size: 11px;
}

.sect-marker:hover .sect-marker__core,
.sect-marker.is-active .sect-marker__core {
  transform: translateY(-2px) scale(1.06);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.34);
}

.sect-marker.is-active .sect-marker__label {
  border-color: rgba(90, 214, 138, 0.6);
  color: #ebfff4;
}

.sect-marker.is-my-sect .sect-marker__core {
  background: linear-gradient(135deg, rgba(220, 255, 223, 0.96), rgba(88, 194, 112, 0.96));
}

.sect-map-tip {
  padding: 14px 16px;
  border-radius: 14px;
  background: linear-gradient(90deg, rgba(11, 20, 34, 0.06), rgba(214, 175, 108, 0.14));
  color: var(--text-secondary, #808695);
  font-size: 13px;
  line-height: 1.7;
  border: 1px solid rgba(177, 142, 92, 0.18);
}

.sect-preview-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sect-preview-card__head {
  display: flex;
  gap: 16px;
  align-items: center;
}

.sect-preview-card__avatar {
  width: 88px;
  height: 88px;
  padding: 4px;
  border-radius: 18px;
  background: linear-gradient(135deg, #efd6a2, #b37a2e);
}

.sect-preview-card__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 14px;
}

.sect-preview-card__info {
  flex: 1;
  min-width: 0;
}

.sect-preview-card__name {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary, #17233d);
}

.sect-preview-card__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  color: var(--text-secondary, #808695);
  font-size: 13px;
}

.sect-preview-card__stats span {
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(45, 140, 240, 0.08);
}

.sect-preview-card__section {
  padding: 14px 16px;
  border-radius: 14px;
  background: rgba(11, 20, 34, 0.04);
}

.sect-preview-card__label {
  margin-bottom: 8px;
  color: var(--text-primary, #17233d);
  font-size: 13px;
  font-weight: 700;
}

.sect-preview-card__desc,
.sect-preview-card__requirement {
  color: var(--text-secondary, #808695);
  line-height: 1.8;
  font-size: 13px;
}

.sect-preview-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* 主界面样式 */


.main-clan-modal >>> .ivu-modal-content {
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}

.main-clan-modal >>> .ivu-modal-body {
  flex: 1;
  overflow: hidden;
  padding: 0;
}

.clan-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.clan-tabs >>> .ivu-tabs-bar {
  margin-bottom: 0;
  padding: 10px 18px 18px;
  background: #ffffff;
  border-bottom: 1px solid #f0e5d4;
}

.clan-tabs >>> .ivu-tabs-nav-container {
  font-size: 14px;
}

.clan-tabs >>> .ivu-tabs-nav-wrap {
  overflow-x: auto;
  overflow-y: hidden;
}

.clan-tabs >>> .ivu-tabs-nav {
  display: flex;
  gap: 10px;
  white-space: nowrap;
}

.clan-tabs >>> .ivu-tabs-tab {
  margin-right: 0;
  padding: 10px 18px;
  border-radius: 999px;
  background: #f8f3ea;
  color: #6e5731;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 600;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.clan-tabs >>> .ivu-tabs-tab:hover {
  color: #8b5a18;
  background: #f4ebde;
  border-color: #e8d7bd;
}

.clan-tabs >>> .ivu-tabs-tab-active {
  color: #fff;
  background: linear-gradient(135deg, #8e6428, #cda15b);
  box-shadow: 0 10px 22px rgba(141, 99, 39, 0.22);
}

.clan-tabs >>> .ivu-tabs-ink-bar {
  display: none !important;
}

.clan-tabs >>> .ivu-tabs-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 20px 36px;
  background: #ffffff;
  overscroll-behavior: contain;
}

.clan-tabs >>> .ivu-tabs-content-animated {
  min-height: 100%;
}

.clan-tabs >>> .ivu-tabs-tabpane {
  height: 100%;
  min-height: 100%;
}

.clan-tabs >>> .ivu-tabs-tabpane::before {
  content: "";
  display: block;
  height: 8px;
}

.disciples-readonly-tag {
  color: #8a7454;
  font-size: 12px;
}

.sect-task-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
}

.sect-task-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-radius: 20px;
  background:
    radial-gradient(circle at 12% 15%, rgba(205, 161, 91, 0.28), transparent 28%),
    linear-gradient(135deg, #fff7e8, #f6efe5);
  border: 1px solid #ecd9ba;
}

.sect-task-eyebrow {
  margin-bottom: 6px;
  color: #8b5a18;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.sect-task-hero h3 {
  margin: 0 0 6px;
  color: #2d2417;
  font-size: 22px;
}

.sect-task-hero p {
  margin: 0;
  color: #8a7454;
  font-size: 13px;
}

.sect-contribution-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.contribution-card {
  padding: 15px;
  border-radius: 16px;
  background: #fffaf2;
  border: 1px solid #efe0c8;
  box-shadow: 0 10px 24px rgba(92, 64, 28, 0.08);
}

.contribution-card span,
.contribution-card small {
  display: block;
  color: #9a8563;
  font-size: 12px;
}

.contribution-card strong {
  display: block;
  margin: 6px 0;
  color: #8b5a18;
  font-size: 24px;
}

.sect-task-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  gap: 16px;
}

.panel-card {
  position: relative;
  padding: 16px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #eee1ce;
  box-shadow: 0 10px 24px rgba(92, 64, 28, 0.06);
}

.panel-card-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.panel-card-head h4 {
  margin: 0;
  color: #2d2417;
  font-size: 16px;
}

.panel-card-head span {
  color: #9a8563;
  font-size: 12px;
}

.sect-task-item {
  padding: 14px;
  margin-bottom: 12px;
  border-radius: 14px;
  border: 1px solid #efe0c8;
  background: linear-gradient(180deg, #fffdf8, #fbf3e7);
}

.task-item-top,
.task-item-bottom,
.task-requirement,
.donate-row,
.rank-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.task-item-top {
  justify-content: space-between;
  align-items: flex-start;
}

.task-item-top h4 {
  margin: 0 0 6px;
  color: #2d2417;
  font-size: 15px;
}

.task-item-top p {
  margin: 0;
  color: #8a7454;
  font-size: 12px;
  line-height: 1.6;
}

.task-requirements {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 0;
}

.task-requirement {
  justify-content: space-between;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(205, 161, 91, 0.1);
}

.requirement-name {
  flex: 1;
  color: #3f3222;
}

.requirement-progress,
.task-reward {
  color: #8b5a18;
  font-weight: 700;
}

.task-item-bottom {
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
}

.task-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.sect-task-side {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.donate-card .ivu-select {
  flex: 1;
  min-width: 0;
}

.donate-card .ivu-input-number {
  width: 88px;
}

.donate-row {
  margin-bottom: 12px;
}

.donate-row--material {
  align-items: flex-start;
}

.donate-label {
  width: 48px;
  padding-top: 4px;
  color: #3f3222;
  font-size: 12px;
  font-weight: 700;
}

.rank-row {
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #ead9bd;
}

.rank-row:last-child {
  border-bottom: 0;
}

.rank-no {
  width: 42px;
  color: #8b5a18;
  font-weight: 700;
}

.rank-name {
  flex: 1;
  color: #3f3222;
}

.rank-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.empty-hint {
  padding: 18px;
  border-radius: 12px;
  color: #9a8563;
  background: #fff8ed;
  text-align: center;
}

.empty-hint.small {
  padding: 10px;
  font-size: 12px;
}

.sect-favor-panel {
  min-height: 100%;
}

.sect-favor-layout {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 16px;
}

.sect-favor-list {
  align-self: start;
}

.favor-sect-card {
  padding: 12px;
  margin-bottom: 10px;
  border: 1px solid #efe0c8;
  border-radius: 12px;
  background: #fffaf2;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.favor-sect-card.active {
  border-color: #c8903d;
  box-shadow: 0 8px 18px rgba(152, 102, 35, 0.14);
}

.favor-sect-main,
.favor-progress-row,
.favor-toolbar,
.favor-shop-meta,
.favor-shop-action {
  display: flex;
  align-items: center;
  gap: 8px;
}

.favor-sect-main {
  justify-content: space-between;
  margin-bottom: 8px;
}

.favor-sect-main strong,
.favor-shop-name {
  color: #2d2417;
}

.favor-progress-row {
  margin-bottom: 6px;
}

.favor-progress-row .ivu-progress {
  flex: 1;
}

.favor-progress-row span,
.favor-sect-card small,
.favor-shop-meta,
.favor-shop-item small {
  color: #9a8563;
  font-size: 12px;
}

.sect-favor-main {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr);
  gap: 16px;
}

.favor-task-card,
.favor-shop-card {
  min-height: 360px;
}

.favor-toolbar {
  justify-content: flex-end;
  margin-bottom: 12px;
}

.favor-task-item {
  background: linear-gradient(180deg, #fffdf8, #f7fbf8);
}

.favor-shop-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.favor-shop-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e6dbc8;
  border-radius: 12px;
  background: #fffdf8;
}

.favor-shop-item.locked {
  opacity: 0.68;
}

.favor-shop-name {
  margin-bottom: 6px;
  font-weight: 700;
}

.favor-shop-meta {
  flex-wrap: wrap;
}

.favor-shop-action {
  justify-content: flex-end;
}

.favor-shop-action strong {
  color: #8b5a18;
  white-space: nowrap;
}

.favor-shop-item small {
  grid-column: 1 / -1;
}

.rank-empty-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.special-building-panel {
  position: relative;
  min-height: 420px;
}

.special-building-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  padding: 14px 16px;
  border: 1px solid #efe0c8;
  border-radius: 14px;
  background: #fffaf2;
}

.special-building-toolbar h4 {
  margin: 0 0 4px;
  color: #2d2417;
  font-size: 16px;
}

.special-building-toolbar span,
.special-building-card__head p,
.special-building-action-line span,
.special-building-state span,
.special-building-state small {
  color: #9a8563;
  font-size: 12px;
}

.special-building-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 16px;
}

.special-building-main {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.special-building-card {
  padding: 16px;
  border: 1px solid #eee1ce;
  border-radius: 16px;
  background: linear-gradient(180deg, #fffdf8, #fbf3e7);
  box-shadow: 0 10px 24px rgba(92, 64, 28, 0.06);
}

.special-building-card__head,
.special-building-title-row,
.special-building-progress__meta,
.special-building-action-line,
.special-building-action-control,
.special-building-state {
  display: flex;
  align-items: center;
  gap: 10px;
}

.special-building-card__head {
  justify-content: space-between;
  align-items: flex-start;
}

.special-building-title-row {
  align-items: baseline;
  flex-wrap: wrap;
}

.special-building-title-row h4 {
  margin: 0;
  color: #2d2417;
  font-size: 17px;
}

.special-building-card__head p {
  margin: 6px 0 0;
  line-height: 1.6;
}

.special-building-level {
  min-width: 64px;
  padding: 8px 10px;
  border-radius: 12px;
  background: rgba(205, 161, 91, 0.12);
  text-align: center;
}

.special-building-level span {
  display: block;
  color: #9a8563;
  font-size: 12px;
}

.special-building-level strong {
  display: block;
  color: #8b5a18;
  font-size: 22px;
  line-height: 1.2;
}

.special-building-progress {
  margin: 14px 0;
}

.special-building-progress__meta {
  justify-content: space-between;
  margin-bottom: 6px;
  color: #8b5a18;
  font-size: 12px;
}

.special-building-desc-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.special-building-desc-grid > div {
  padding: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(238, 225, 206, 0.78);
}

.special-building-desc-grid span {
  display: block;
  margin-bottom: 4px;
  color: #9a8563;
  font-size: 12px;
}

.special-building-desc-grid strong {
  color: #3f3222;
  font-size: 13px;
  line-height: 1.5;
}

.special-building-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.special-building-action-line {
  justify-content: space-between;
  padding: 10px;
  border-radius: 12px;
  background: rgba(205, 161, 91, 0.1);
}

.special-building-action-line strong {
  display: block;
  margin-bottom: 4px;
  color: #2d2417;
}

.special-building-action-control {
  justify-content: flex-end;
  flex-wrap: wrap;
}

.special-building-action-control .ivu-input-number {
  width: 78px;
}

.special-building-use-cost {
  color: #7b5b2c;
  font-size: 12px;
  white-space: nowrap;
}

.special-building-business {
  padding: 10px;
  border-radius: 12px;
  border: 1px solid rgba(205, 161, 91, 0.24);
  background: rgba(255, 255, 255, 0.62);
}

.special-building-business__head,
.special-building-business__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.special-building-business__head {
  margin-bottom: 8px;
}

.special-building-business__head span,
.special-building-business__item span {
  color: #9a8563;
  font-size: 12px;
}

.special-building-business__item {
  padding: 8px 0;
  border-top: 1px dashed rgba(205, 161, 91, 0.32);
}

.special-building-business__item strong {
  margin-bottom: 2px;
}

.special-building-business__action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 8px;
}

.special-building-side {
  min-width: 0;
}

.special-building-state-card {
  min-height: 220px;
}

.special-building-state {
  align-items: flex-start;
  flex-direction: column;
  padding: 10px 0;
  border-bottom: 1px dashed #ead9bd;
}

.special-building-state:last-child {
  border-bottom: 0;
}

.special-building-state strong {
  color: #2d2417;
}

.submit-task-tip {
  margin-bottom: 12px;
  color: #2d2417;
  font-weight: 700;
}

@media (max-width: 900px) {
  .sect-contribution-grid,
  .sect-task-layout,
  .sect-favor-layout,
  .sect-favor-main,
  .special-building-layout,
  .special-building-desc-grid {
    grid-template-columns: 1fr;
  }

  .special-building-action-line {
    align-items: flex-start;
    flex-direction: column;
  }
}

/* 宗门信息面板 */
.sect-info-panel {
  height: 100%;
}

.sect-header-info {
  display: flex;
  gap: 30px;
  padding: 24px;
  border: 1px solid #eee1ce;
  border-radius: 20px;
  margin-bottom: 18px;
  background: linear-gradient(135deg, #fffdf9, #ffffff);
  box-shadow: 0 10px 24px rgba(58, 40, 17, 0.05);
}

.sect-avatar-large {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 24px;
  overflow: hidden;
  flex-shrink: 0;
  border: 4px solid rgba(177, 142, 92, 0.82);
  box-shadow: 0 18px 32px rgba(32, 22, 11, 0.16);
}

.sect-avatar-large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sect-level {
  position: absolute;
  top: 10px;
  right: 10px;
  background: var(--primary-color, #2d8cf0);
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: bold;
}

.sect-main-info {
  flex: 1;
}

.sect-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.sect-title {
  font-size: 30px;
  font-weight: 700;
  color: var(--text-primary, #17233d);
  margin: 0;
  letter-spacing: 0.06em;
}

.sect-chip {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(214, 175, 108, 0.14);
  color: #8b5a18;
  font-size: 12px;
  font-weight: 700;
}

.sect-description {
  color: var(--text-secondary, #808695);
  line-height: 1.8;
  margin: 0 0 14px 0;
  font-size: 14px;
  max-width: 720px;
}

.sect-impression-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.impression-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(17, 29, 47, 0.06);
  color: #61513a;
  font-size: 12px;
}

.sect-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fffdfa;
  border-radius: 16px;
  border: 1px solid #efe3d4;
  box-shadow: none;
}

.stat-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-color, #2d8cf0);
  color: white;
  border-radius: 50%;
  font-size: 16px;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 12px;
  color: var(--text-secondary, #808695);
  margin-bottom: 4px;
  letter-spacing: 0.08em;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary, #17233d);
}

.sect-summary-band {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.sect-summary-band__item {
  padding: 16px 18px;
  border-radius: 18px;
  border: 1px solid #efe3d4;
  background: #fffdfa;
}

.sect-summary-band__label {
  display: block;
  margin-bottom: 8px;
  color: var(--text-secondary, #808695);
  font-size: 12px;
  letter-spacing: 0.08em;
}

.sect-summary-band__value {
  font-size: 26px;
  line-height: 1;
  color: #4c3821;
}

.sect-summary-band__value--accent {
  color: #b26b1d;
}

.sect-buffs {
  margin-bottom: 20px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #17233d);
  margin: 0 0 15px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.04em;
}

.buff-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
}

.buff-item {
  padding: 14px 16px;
  background: #fffdfa;
  border-radius: 16px;
  border: 1px solid #efe3d4;
  transition: all 0.3s ease;
  box-shadow: 0 8px 18px rgba(58, 40, 17, 0.04);
}

.buff-item.active {
  border-color: rgba(59, 176, 92, 0.55);
  background: linear-gradient(180deg, rgba(242, 255, 244, 0.94), rgba(230, 250, 235, 0.94));
  box-shadow: 0 14px 28px rgba(25, 190, 107, 0.12);
}

.buff-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.buff-name {
  font-weight: 600;
  color: var(--text-primary, #17233d);
}

.buff-status {
  font-size: 12px;
  color: var(--success-color, #19be6b);
  padding: 2px 8px;
  background: rgba(25, 190, 107, 0.1);
  border-radius: 10px;
}

.buff-desc {
  margin: 0;
  color: var(--text-secondary, #808695);
  font-size: 13px;
  line-height: 1.5;
}

.sect-actions-panel {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 16px 18px;
  border-radius: 18px;
  background: #fff8ef;
  border: 1px solid #efdebf;
}

.sect-actions-panel >>> .ivu-btn {
  min-width: 116px;
  border-radius: 999px;
}

/* 弟子面板 */
.disciples-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.search-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  padding: 14px;
  border-radius: 16px;
  background: #fffdfa;
  border: 1px solid #efe3d4;
}

.search-bar .ivu-input {
  flex: 1;
}

.disciples-table {
  flex: 1;
  overflow: hidden;
}

.disciples-pagination {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--border-color, #e8eaec);
}

/* 宝库面板 */
.treasure-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.treasure-search {
  margin-bottom: 20px;
  padding: 14px;
  border-radius: 16px;
  background: #fffdfa;
  border: 1px solid #efe3d4;
}

.search-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.treasure-list {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 15px;
  padding: 10px 0;
}

.treasure-item {
  background: #ffffff;
  border: 1px solid #efe3d4;
  border-radius: 18px;
  padding: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(58, 40, 17, 0.05);
}

.treasure-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.treasure-grade-1 {
  border-left: 4px solid #8c94a4;
}
.treasure-grade-2 {
  border-left: 4px solid #0070dd;
}
.treasure-grade-3 {
  border-left: 4px solid #a335ee;
}
.treasure-grade-4 {
  border-left: 4px solid #ff6b6b;
}
.treasure-grade-5 {
  border-left: 4px solid #1eff00;
}
.treasure-grade-6 {
  border-left: 4px solid #ffd700;
}

.treasure-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.treasure-name {
  font-weight: 600;
  color: var(--text-primary, #17233d);
  font-size: 15px;
}c

.treasure-type {
  font-size: 12px;
  color: var(--text-secondary, #808695);
  background: var(--bg-secondary, #f8f8f9);
  padding: 2px 8px;
  border-radius: 10px;
}

.treasure-info {
  margin-bottom: 10px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 13px;
}

.info-label {
  color: var(--text-secondary, #808695);
}

.info-value {
  color: var(--text-primary, #17233d);
  font-weight: 500;
}

.grade-tag {
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
}

.grade-1 { background: #8c94a4; color: white; }
.grade-2 { background: #0070dd; color: white; }
.grade-3 { background: #a335ee; color: white; }
.grade-4 { background: #ff6b6b; color: white; }
.grade-5 { background: #1eff00; color: white; }
.grade-6 { background: #ffd700; color: white; }

.contri-point {
  color: var(--warning-color, #ff9900);
  font-weight: 600;
}

.treasure-actions {
  display: flex;
  gap: 8px;
}

.treasure-pagination {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--border-color, #e8eaec);
}

/* 藏宝阁面板 */
.treasure-hall-panel {
  height: 100%;
  overflow-y: auto;
}

.treasure-hall-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  padding: 20px 0;
}

.treasure-hall-item {
  background: #ffffff;
  border: 1px solid #efe3d4;
  border-radius: 18px;
  padding: 20px;
  box-shadow: 0 8px 20px rgba(58, 40, 17, 0.05);
}

.item-header {
  margin-bottom: 15px;
}

.item-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #17233d);
  margin: 0 0 10px 0;
}

.item-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.meta-tag {
  font-size: 12px;
  color: var(--text-secondary, #808695);
  background: var(--bg-secondary, #f8f8f9);
  padding: 2px 8px;
  border-radius: 10px;
}

.item-materials {
  margin-bottom: 15px;
}

.material {
  padding: 6px 10px;
  background: var(--bg-secondary, #f8f8f9);
  border-radius: 4px;
  margin-bottom: 5px;
  font-size: 13px;
  color: var(--text-primary, #17233d);
  border-left: 3px solid var(--primary-color, #2d8cf0);
}

.item-actions {
  text-align: right;
}

/* 心法面板 */
.xinfa-panel {
  height: 100%;
  overflow-y: auto;
}

.xinfa-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  padding: 20px 0;
}

.xinfa-item {
  background: #ffffff;
  border: 1px solid #efe3d4;
  border-radius: 18px;
  padding: 20px;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(58, 40, 17, 0.05);
}

.xinfa-item.learned {
  border-color: var(--success-color, #19be6b);
  background: rgba(25, 190, 107, 0.03);
}

.xinfa-item.mastered {
  border-color: var(--warning-color, #ff9900);
  background: rgba(255, 153, 0, 0.03);
}

.xinfa-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.xinfa-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #17233d);
  margin: 0;
}

.xinfa-type {
  font-size: 12px;
  color: var(--text-secondary, #808695);
  background: var(--bg-secondary, #f8f8f9);
  padding: 2px 8px;
  border-radius: 10px;
}

.xinfa-desc {
  color: var(--text-secondary, #808695);
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 15px 0;
  min-height: 40px;
}

.xinfa-progress {
  margin-bottom: 15px;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 12px;
  color: var(--text-secondary, #808695);
}

.xinfa-status {
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
}

.status-tag {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
}

.status-tag.mastered {
  background: var(--success-color, #19be6b);
  color: white;
}

.status-tag.learning {
  background: var(--warning-color, #ff9900);
  color: white;
}

.xinfa-actions {
  text-align: right;
}

/* 留言板 */
.message-board-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.message-actions {
  margin-bottom: 20px;
}

.message-list {
  flex: 1;
  overflow-y: auto;
}

.message-item {
  background: #ffffff;
  border: 1px solid #efe3d4;
  border-radius: 18px;
  padding: 16px 18px;
  margin-bottom: 15px;
  box-shadow: 0 8px 18px rgba(58, 40, 17, 0.04);
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.message-author {
  font-weight: 600;
  color: var(--text-primary, #17233d);
}

.message-time {
  font-size: 12px;
  color: var(--text-secondary, #808695);
}

.message-content {
  color: var(--text-primary, #17233d);
  line-height: 1.2;
  margin-bottom: 2px;
  white-space: pre-wrap;
}

/* 捐赠模态框 */
.donate-modal-content {
  max-height: 400px;
  overflow-y: auto;
}

.item-name {
  margin-right: 10px;
  font-weight: 500;
}

.item-grade {
  font-size: 12px;
  color: var(--text-secondary, #808695);
}

.no-items {
  text-align: center;
  padding: 30px;
  color: var(--text-secondary, #808695);
}

/* 装备详情 */
.item-detail {
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
}

.item-detail h3 {
  margin: 0 0 15px 0;
  text-align: center;
}

.item-basic {
  margin-bottom: 15px;
}

.item-basic p {
  margin: 8px 0;
  font-size: 14px;
  color: var(--text-primary, #17233d);
}

.item-attributes {
  margin-bottom: 15px;
}

.attribute {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 13px;
}

.attr-label {
  color: var(--text-secondary, #808695);
}

.attr-value {
  color: var(--text-primary, #17233d);
  font-weight: 500;
}

.item-affixes {
  margin-top: 15px;
}

/* 暗色主题 */
.dark-theme {
  /* 背景颜色 */
  --bg-primary: #373e57 !important;
  --bg-card: #151728;
  --bg-progress: rgba(255, 255, 255, 0.1);
  --bg-table-header: rgba(73, 117, 212, 0.1);
  --bg-hover: rgba(73, 117, 212, 0.15);
  --bg-sidebar: rgba(30, 30, 45, 0.95);

  --card-bg: rgba(30, 32, 42, 0.9);
  --bg-secondary: rgba(40, 42, 54, 0.8);
  --border-color: rgba(73, 117, 212, 0.2);
  /* 文字颜色 */
  --text-primary: #9c9cab;
  --text-secondary: #808695;
  --text-title: #4975d4;
  --text-accent: #5c9eff;

  --text-tertiary: #808080;
  --primary-color: #4975d4;
  --success-color: #36d571;
  --warning-color: #ffaa00;
  --error-color: #ff4d4f;


  /* 表格颜色 */
  --table-header-bg:rgba(73, 117, 212, 0.1);
  --table-row-hover: rgba(73, 117, 212, 0.2);
  --table-border: rgba(73, 117, 212, 0.2);
}

.dark-theme .sect-card,
.dark-theme .stat-item,
.dark-theme .buff-item,
.dark-theme .treasure-item,
.dark-theme .treasure-hall-item,
.dark-theme .xinfa-item,
.dark-theme .message-item {
  background: rgba(30, 32, 42, 0.9);
  border-color: rgba(73, 117, 212, 0.2);
}

.dark-theme .main-clan-content,
.dark-theme .sect-map-shell {
  background:
    radial-gradient(circle at top left, rgba(73, 117, 212, 0.16), transparent 30%),
    linear-gradient(180deg, rgba(20, 23, 38, 0.96), rgba(27, 30, 45, 0.94));
  border-color: rgba(73, 117, 212, 0.22);
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.28);
}

.dark-theme .sect-map-hero__copy,
.dark-theme .sect-header-info,
.dark-theme .sect-summary-band__item,
.dark-theme .search-bar,
.dark-theme .treasure-search {
  background: linear-gradient(135deg, rgba(29, 33, 48, 0.94), rgba(19, 22, 35, 0.94));
  border-color: rgba(73, 117, 212, 0.2);
}

.dark-theme .clan-tabs >>> .ivu-tabs-bar,
.dark-theme .clan-tabs >>> .ivu-tabs-content {
  background: linear-gradient(180deg, rgba(21, 24, 40, 0.98), rgba(24, 27, 43, 0.94));
}

.dark-theme .clan-tabs >>> .ivu-tabs-tab {
  background: rgba(73, 117, 212, 0.12);
  color: #9cb7ff;
  border-color: transparent;
}

.dark-theme .clan-tabs >>> .ivu-tabs-tab:hover {
  color: #dbe6ff;
  background: rgba(73, 117, 212, 0.22);
  border-color: rgba(73, 117, 212, 0.26);
}

.dark-theme .clan-tabs >>> .ivu-tabs-tab-active {
  background: linear-gradient(135deg, #375caf, #5576c4);
  color: #fff;
}

.dark-theme .sect-map-hero__eyebrow,
.dark-theme .sect-chip,
.dark-theme .sect-summary-band__value,
.dark-theme .impression-pill {
  color: #c8d7ff;
}

.dark-theme .sect-chip,
.dark-theme .impression-pill {
  background: rgba(73, 117, 212, 0.14);
}

.dark-theme .sect-map-tip {
  background: linear-gradient(90deg, rgba(73, 117, 212, 0.12), rgba(255, 170, 0, 0.08));
  border-color: rgba(73, 117, 212, 0.18);
}

.dark-theme .sect-card:hover,
.dark-theme .treasure-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.dark-theme .meta-tag,
.dark-theme .treasure-type,
.dark-theme .xinfa-type {
  background: rgba(40, 42, 54, 0.8);
}

.sect-hire-hall-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.sect-hire-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  border: 1px solid rgba(73, 117, 212, 0.14);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.72);
}

.sect-hire-section__head,
.sect-hire-row,
.sect-hire-card {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
}

.sect-hire-row > div,
.sect-hire-card__meta {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.sect-hire-row span,
.sect-hire-card span {
  color: #6b7280;
  font-size: 12px;
}

.sect-hire-card {
  padding: 8px 0;
  border-top: 1px solid rgba(73, 117, 212, 0.12);
}

.dark-theme .sect-hire-section {
  background: rgba(28, 32, 48, 0.72);
  border-color: rgba(73, 117, 212, 0.22);
}

.dark-theme .sect-hire-row span,
.dark-theme .sect-hire-card span {
  color: #aab6d3;
}

/* 浅色主题与主体页面保持一致：白底、灰色分隔、蓝色强调。 */
.clan-modal-wrapper:not(.dark-theme) {
  --bg-primary: #ffffff;
  --bg-card: #ffffff;
  --bg-secondary: #f7f8fa;
  --card-bg: #ffffff;
  --border-color: #e8eaec;
  --text-primary: #17233d;
  --text-secondary: #808695;
  --text-title: #17233d;
  --text-accent: #2d8cf0;
  --primary-color: #2d8cf0;
  --table-header-bg: #f7f8fa;
  --table-row-hover: #f5f7f9;
  --table-border: #e8eaec;
}

.clan-modal-wrapper:not(.dark-theme) .main-clan-content,
.clan-modal-wrapper:not(.dark-theme) .sect-map-shell {
  background: #fff;
  border-color: #e8eaec;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(23, 35, 61, 0.06);
}

.clan-modal-wrapper:not(.dark-theme) .sect-detail-toolbar,
.clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-bar,
.clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-content {
  background: #fff;
  border-color: #e8eaec;
}

.clan-modal-wrapper:not(.dark-theme) .sect-detail-toolbar__title h3,
.clan-modal-wrapper:not(.dark-theme) .sect-map-title,
.clan-modal-wrapper:not(.dark-theme) .sect-title,
.clan-modal-wrapper:not(.dark-theme) .sect-card h3,
.clan-modal-wrapper:not(.dark-theme) .panel-title,
.clan-modal-wrapper:not(.dark-theme) .section-title {
  color: #17233d;
}

.clan-modal-wrapper:not(.dark-theme) .sect-detail-toolbar__eyebrow,
.clan-modal-wrapper:not(.dark-theme) .sect-map-hero__eyebrow,
.clan-modal-wrapper:not(.dark-theme) .sect-map-hero__quote-label {
  color: #2d8cf0;
  letter-spacing: 0;
}

.clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-tab {
  color: #515a6e;
  background: transparent;
  border-color: transparent;
  border-radius: 4px;
}

.clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-tab:hover {
  color: #2d8cf0;
  background: #f5f7f9;
}

.clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-tab-active {
  color: #2d8cf0;
  background: #edf5ff;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .sect-card,
.clan-modal-wrapper:not(.dark-theme) .panel-card,
.clan-modal-wrapper:not(.dark-theme) .stat-item,
.clan-modal-wrapper:not(.dark-theme) .buff-item,
.clan-modal-wrapper:not(.dark-theme) .treasure-item,
.clan-modal-wrapper:not(.dark-theme) .treasure-hall-item,
.clan-modal-wrapper:not(.dark-theme) .xinfa-item,
.clan-modal-wrapper:not(.dark-theme) .message-item,
.clan-modal-wrapper:not(.dark-theme) .sect-task-item,
.clan-modal-wrapper:not(.dark-theme) .sect-hire-section,
.clan-modal-wrapper:not(.dark-theme) .sect-map-hero__copy,
.clan-modal-wrapper:not(.dark-theme) .sect-map-hero__quote,
.clan-modal-wrapper:not(.dark-theme) .sect-preview-card__section,
.clan-modal-wrapper:not(.dark-theme) .sect-header-info,
.clan-modal-wrapper:not(.dark-theme) .sect-summary-band__item,
.clan-modal-wrapper:not(.dark-theme) .search-bar,
.clan-modal-wrapper:not(.dark-theme) .treasure-search {
  color: #17233d;
  background: #fff;
  background-image: none;
  border-color: #e8eaec;
  border-radius: 6px;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .sect-card:hover,
.clan-modal-wrapper:not(.dark-theme) .treasure-item:hover,
.clan-modal-wrapper:not(.dark-theme) .xinfa-item:hover,
.clan-modal-wrapper:not(.dark-theme) .sect-task-item:hover {
  border-color: #b8d6f7;
  background: #f8fbff;
  box-shadow: 0 2px 8px rgba(45, 140, 240, 0.08);
}

.clan-modal-wrapper:not(.dark-theme) .sect-map-hero__quote,
.clan-modal-wrapper:not(.dark-theme) .sect-map-tip,
.clan-modal-wrapper:not(.dark-theme) .sect-chip,
.clan-modal-wrapper:not(.dark-theme) .impression-pill,
.clan-modal-wrapper:not(.dark-theme) .meta-tag,
.clan-modal-wrapper:not(.dark-theme) .treasure-type,
.clan-modal-wrapper:not(.dark-theme) .xinfa-type {
  color: #515a6e;
  background: #f7f8fa;
  background-image: none;
  border-color: #e8eaec;
}

.clan-modal-wrapper:not(.dark-theme) .sect-map-hero__quote::after {
  display: none;
}

.clan-modal-wrapper:not(.dark-theme) .sect-summary-band__value,
.clan-modal-wrapper:not(.dark-theme) .stat-value,
.clan-modal-wrapper:not(.dark-theme) .sect-chip.is-active {
  color: #2d8cf0;
}

.clan-modal-wrapper:not(.dark-theme) .ivu-table th {
  color: #515a6e;
  background: #f7f8fa;
}

.clan-modal-wrapper:not(.dark-theme) .ivu-table td,
.clan-modal-wrapper:not(.dark-theme) .ivu-table th {
  border-color: #e8eaec;
}

.clan-modal-wrapper:not(.dark-theme) .ivu-input,
.clan-modal-wrapper:not(.dark-theme) .ivu-select-selection,
.clan-modal-wrapper:not(.dark-theme) .ivu-input-number {
  color: #17233d;
  background: #fff;
  border-color: #dcdee2;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .ivu-input:hover,
.clan-modal-wrapper:not(.dark-theme) .ivu-select-selection:hover,
.clan-modal-wrapper:not(.dark-theme) .ivu-input-number:hover {
  border-color: #57a3f3;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .sect-map-hero {
    grid-template-columns: 1fr;
  }

  .sect-stats-grid,
  .sect-summary-band {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .treasure-list,
  .xinfa-list {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}

@media (max-width: 768px) {
  .main-clan-modal >>> .ivu-modal {
    width: 95% !important;
    top: 50px !important;
  }

  .main-clan-content {
    height: calc(100vh - 80px);
  }

  .sect-map-toolbar {
    flex-direction: column;
  }

  .sect-map-shell {
    padding: 12px;
  }

  .sect-world-map {
    min-height: 480px;
  }

  .sect-marker__core {
    width: 50px;
    height: 50px;
  }

  .sect-marker__label {
    padding: 4px 9px;
  }

  .sect-header-info {
    flex-direction: column;
    gap: 20px;
    padding: 18px;
  }

  .sect-avatar-large {
    width: 120px;
    height: 120px;
    margin: 0 auto;
  }

  .sect-stats-grid,
  .sect-summary-band {
    grid-template-columns: 1fr;
  }

  .search-filters {
    flex-direction: column;
  }

  .search-filters .ivu-input,
  .search-filters .ivu-select {
    width: 100% !important;
    margin-left: 0 !important;
  }
}

@media (max-width: 480px) {
  .treasure-list,
  .xinfa-list,
  .treasure-hall-list {
    grid-template-columns: 1fr;
  }

  .sect-actions-panel {
    flex-direction: column;
  }

  .sect-actions-panel .ivu-btn {
    width: 100%;
  }

  .sect-title {
    font-size: 24px;
  }

  .clan-tabs >>> .ivu-tabs-bar {
    padding: 12px 12px 16px;
  }

  .clan-tabs >>> .ivu-tabs-content {
    padding: 18px 12px 32px;
  }

  .clan-tabs >>> .ivu-tabs-tab {
    padding: 8px 14px;
    font-size: 12px;
  }
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* 简单的响应式样式 */
.simple-search-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
}
/* PC端：固定宽度 */
@media (min-width: 769px) {
  .search-field {
    width: 180px !important;
  }

  .number-field {
    width: 120px !important;
  }

  .action-btn {
    margin-left: 8px;
  }
}

/* 移动端：自适应宽度 */
@media (max-width: 768px) {
  .simple-search-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 两列网格 */
    gap: 8px;
    align-items: center;
  }

  .search-field,
  .action-btn {
    width: 100% !important;
    margin-left: 0 !important;
    margin-bottom: 8px;
  }

  .action-btn:last-child {
    margin-bottom: 0;
  }
}
</style>

<style>
/* 宗门任务/特殊建筑统一跟随 index2 简约白主题 */
.clan-modal-wrapper:not(.dark-theme) .sect-task-hero,
.clan-modal-wrapper:not(.dark-theme) .contribution-card,
.clan-modal-wrapper:not(.dark-theme) .panel-card,
.clan-modal-wrapper:not(.dark-theme) .sect-task-item,
.clan-modal-wrapper:not(.dark-theme) .special-building-toolbar,
.clan-modal-wrapper:not(.dark-theme) .special-building-card,
.clan-modal-wrapper:not(.dark-theme) .special-building-state-card,
.clan-modal-wrapper:not(.dark-theme) .favor-task-card,
.clan-modal-wrapper:not(.dark-theme) .special-building-business,
.clan-modal-wrapper:not(.dark-theme) .sect-hire-section {
  background: #fff !important;
  background-image: none !important;
  border-color: #e8eaec !important;
  box-shadow: 0 2px 10px rgba(23, 35, 61, 0.06) !important;
  color: #17233d !important;
}

.clan-modal-wrapper:not(.dark-theme) .sect-task-hero h3,
.clan-modal-wrapper:not(.dark-theme) .sect-task-item h4,
.clan-modal-wrapper:not(.dark-theme) .panel-card-head h4,
.clan-modal-wrapper:not(.dark-theme) .special-building-toolbar h4,
.clan-modal-wrapper:not(.dark-theme) .special-building-title-row h4,
.clan-modal-wrapper:not(.dark-theme) .special-building-action-line strong {
  color: #17233d !important;
}

.clan-modal-wrapper:not(.dark-theme) .sect-task-hero p,
.clan-modal-wrapper:not(.dark-theme) .sect-task-item p,
.clan-modal-wrapper:not(.dark-theme) .special-building-toolbar span,
.clan-modal-wrapper:not(.dark-theme) .special-building-card__head p,
.clan-modal-wrapper:not(.dark-theme) .special-building-action-line span,
.clan-modal-wrapper:not(.dark-theme) .special-building-state span,
.clan-modal-wrapper:not(.dark-theme) .special-building-state small {
  color: #808695 !important;
}

.clan-modal-wrapper:not(.dark-theme) .task-requirement,
.clan-modal-wrapper:not(.dark-theme) .special-building-action-line,
.clan-modal-wrapper:not(.dark-theme) .special-building-level {
  background: #f7f8fa !important;
  border-color: #e8eaec !important;
}

.clan-modal-wrapper:not(.dark-theme) .requirement-name,
.clan-modal-wrapper:not(.dark-theme) .special-building-desc-grid strong {
  color: #515a6e !important;
}

.clan-modal-wrapper:not(.dark-theme) .task-reward,
.clan-modal-wrapper:not(.dark-theme) .requirement-progress,
.clan-modal-wrapper:not(.dark-theme) .special-building-level strong,
.clan-modal-wrapper:not(.dark-theme) .special-building-progress__meta {
  color: #2d8cf0 !important;
}

.clan-modal-wrapper:not(.dark-theme) .special-building-desc-grid > div {
  background: #f7f8fa !important;
  border-color: #e8eaec !important;
}

/* 白蓝紧凑版：宗门列表沿用洞府的长条信息密度。 */
.clan-modal-wrapper:not(.dark-theme) .sect-task-panel,
.clan-modal-wrapper:not(.dark-theme) .disciples-panel,
.clan-modal-wrapper:not(.dark-theme) .treasure-panel,
.clan-modal-wrapper:not(.dark-theme) .xinfa-panel {
  color: #17233d;
}

.clan-modal-wrapper:not(.dark-theme) .sect-header-info {
  gap: 18px;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  border-color: #dfe9f5;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .sect-avatar-large {
  width: 96px;
  height: 96px;
  border-width: 2px;
  border-radius: 8px;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .sect-title {
  font-size: 24px;
  letter-spacing: 0;
}

.clan-modal-wrapper:not(.dark-theme) .sect-impression-row {
  gap: 6px;
  margin-bottom: 10px;
}

.clan-modal-wrapper:not(.dark-theme) .impression-pill {
  padding: 4px 8px;
  border-radius: 4px;
  color: #515a6e;
  background: #f5f8fc;
  border: 1px solid #e3ebf5;
}

.clan-modal-wrapper:not(.dark-theme) .sect-stats-grid {
  gap: 8px;
}

.clan-modal-wrapper:not(.dark-theme) .stat-item,
.clan-modal-wrapper:not(.dark-theme) .sect-summary-band__item,
.clan-modal-wrapper:not(.dark-theme) .buff-item {
  border-radius: 6px;
  border-color: #e3ebf5;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .stat-item {
  padding: 9px 10px;
}

.clan-modal-wrapper:not(.dark-theme) .stat-value {
  font-size: 20px;
}

.clan-modal-wrapper:not(.dark-theme) .sect-summary-band {
  gap: 8px;
  margin-bottom: 12px;
}

.clan-modal-wrapper:not(.dark-theme) .sect-summary-band__item {
  padding: 10px 12px;
}

.clan-modal-wrapper:not(.dark-theme) .sect-summary-band__value {
  font-size: 21px;
}

.clan-modal-wrapper:not(.dark-theme) .sect-buffs {
  margin-bottom: 12px;
}

.clan-modal-wrapper:not(.dark-theme) .buff-list {
  gap: 8px;
}

.clan-modal-wrapper:not(.dark-theme) .buff-item {
  padding: 10px 12px;
}

.clan-modal-wrapper:not(.dark-theme) .sect-actions-panel {
  gap: 8px;
  padding: 10px 12px;
  border-radius: 6px;
  background: #f7faff;
  border-color: #dfe9f5;
}

.clan-modal-wrapper:not(.dark-theme) .sect-actions-panel >>> .ivu-btn {
  min-width: 96px;
  border-radius: 4px;
}

.clan-modal-wrapper:not(.dark-theme) .sect-contribution-grid {
  gap: 8px;
}

.clan-modal-wrapper:not(.dark-theme) .contribution-card {
  padding: 10px 12px;
  border-radius: 6px;
  background: #fff;
  border-color: #dfe9f5;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .contribution-card strong {
  margin: 4px 0;
  font-size: 19px;
  color: #2d8cf0;
}

.clan-modal-wrapper:not(.dark-theme) .sect-task-layout {
  grid-template-columns: minmax(0, 1fr) 270px;
  gap: 10px;
}

.clan-modal-wrapper:not(.dark-theme) .panel-card {
  padding: 12px;
  border-radius: 6px;
  border-color: #dfe9f5;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .panel-card-head {
  margin-bottom: 8px;
}

.clan-modal-wrapper:not(.dark-theme) .sect-task-item {
  margin-bottom: 8px;
  padding: 10px 12px;
  border-radius: 6px;
  border-color: #dfe9f5;
  background: #fff;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .sect-task-item:last-child {
  margin-bottom: 0;
}

.clan-modal-wrapper:not(.dark-theme) .task-item-top h4 {
  margin-bottom: 3px;
  font-size: 14px;
}

.clan-modal-wrapper:not(.dark-theme) .task-item-top p {
  line-height: 1.45;
}

.clan-modal-wrapper:not(.dark-theme) .task-requirements {
  gap: 5px;
  margin: 8px 0;
}

.clan-modal-wrapper:not(.dark-theme) .task-requirement {
  min-height: 32px;
  padding: 5px 8px;
  border-radius: 4px;
  background: #f7faff;
  border: 1px solid #e3edf8;
}

.clan-modal-wrapper:not(.dark-theme) .task-actions,
.clan-modal-wrapper:not(.dark-theme) .rank-actions {
  gap: 5px;
}

.clan-modal-wrapper:not(.dark-theme) .sect-task-side {
  gap: 10px;
}

.clan-modal-wrapper:not(.dark-theme) .rank-card {
  padding: 10px 12px;
}

.clan-modal-wrapper:not(.dark-theme) .rank-row {
  min-height: 34px;
  padding: 5px 0;
}

.clan-modal-wrapper:not(.dark-theme) .search-bar,
.clan-modal-wrapper:not(.dark-theme) .treasure-search {
  margin-bottom: 10px;
  padding: 8px;
  border-radius: 6px;
  background: #fff;
  border-color: #dfe9f5;
}

.clan-modal-wrapper:not(.dark-theme) .search-bar .ivu-btn,
.clan-modal-wrapper:not(.dark-theme) .action-btn {
  border-radius: 4px;
}

.clan-modal-wrapper:not(.dark-theme) .disciples-list {
  flex: 1;
  overflow-y: auto;
  border-top: 1px solid #e8eef6;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-list-row {
  display: grid;
  grid-template-columns: 34px minmax(150px, 1.5fr) 70px minmax(120px, 1fr) 80px 68px;
  align-items: center;
  gap: 12px;
  min-height: 58px;
  padding: 8px 10px;
  border-bottom: 1px solid #e8eef6;
  background: #fff;
  transition: background .18s ease;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-list-row:hover {
  background: #f7faff;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-avatar {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 4px;
  color: #2d8cf0;
  background: #edf5ff;
  border: 1px solid #cfe3fb;
  font-size: 14px;
  font-weight: 700;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-main,
.clan-modal-wrapper:not(.dark-theme) .disciple-meta {
  min-width: 0;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-main strong,
.clan-modal-wrapper:not(.dark-theme) .disciple-meta strong,
.clan-modal-wrapper:not(.dark-theme) .disciple-meta span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-main strong {
  color: #17233d;
  font-size: 13px;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-main span,
.clan-modal-wrapper:not(.dark-theme) .disciple-meta small {
  display: block;
  margin-top: 3px;
  overflow: hidden;
  color: #808695;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-meta strong {
  color: #2d8cf0;
  font-size: 13px;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-meta span {
  color: #515a6e;
  font-size: 12px;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-action {
  text-align: right;
}

.clan-modal-wrapper:not(.dark-theme) .disciple-action >>> .ivu-btn {
  min-width: 52px;
  padding: 3px 8px;
  border-radius: 4px;
}

.clan-modal-wrapper:not(.dark-theme) .disciples-list-state {
  padding: 24px 12px;
  color: #808695;
  text-align: center;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-list,
.clan-modal-wrapper:not(.dark-theme) .treasure-hall-list,
.clan-modal-wrapper:not(.dark-theme) .xinfa-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  overflow-y: auto;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-item,
.clan-modal-wrapper:not(.dark-theme) .treasure-hall-item,
.clan-modal-wrapper:not(.dark-theme) .xinfa-item {
  border-radius: 0;
  border-width: 0 0 1px;
  border-color: #e8eef6;
  background: #fff;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 10px 8px 10px 12px;
  border-left-width: 3px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-item:hover,
.clan-modal-wrapper:not(.dark-theme) .treasure-hall-item:hover,
.clan-modal-wrapper:not(.dark-theme) .xinfa-item:hover {
  transform: none;
  background: #f7faff;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-header,
.clan-modal-wrapper:not(.dark-theme) .treasure-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 14px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-header {
  margin-bottom: 5px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-name {
  color: #17233d;
  font-size: 14px;
  font-weight: 600;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-type,
.clan-modal-wrapper:not(.dark-theme) .info-row {
  font-size: 11px;
}

.clan-modal-wrapper:not(.dark-theme) .info-row {
  display: inline-flex;
  gap: 3px;
  margin: 0;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-actions,
.clan-modal-wrapper:not(.dark-theme) .item-actions {
  display: flex;
  gap: 6px;
  align-items: center;
  white-space: nowrap;
}

.clan-modal-wrapper:not(.dark-theme) .xinfa-item {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(190px, 1fr) auto;
  grid-template-rows: auto auto;
  column-gap: 16px;
  align-items: center;
  padding: 10px 8px;
}

.clan-modal-wrapper:not(.dark-theme) .xinfa-header {
  grid-column: 1;
  grid-row: 1;
  margin: 0 0 3px;
}

.clan-modal-wrapper:not(.dark-theme) .xinfa-desc {
  grid-column: 1;
  grid-row: 2;
  min-height: 0;
  margin: 0;
  overflow: hidden;
  color: #808695;
  font-size: 11px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clan-modal-wrapper:not(.dark-theme) .xinfa-progress {
  grid-column: 2;
  grid-row: 1 / span 2;
  width: 100%;
  margin: 0;
}

.clan-modal-wrapper:not(.dark-theme) .xinfa-status {
  grid-column: 3;
  grid-row: 1;
  margin: 0;
  justify-content: flex-end;
}

.clan-modal-wrapper:not(.dark-theme) .xinfa-actions {
  grid-column: 3;
  grid-row: 2;
  text-align: right;
  white-space: nowrap;
}

.clan-modal-wrapper:not(.dark-theme) .xinfa-panel > .ivu-alert {
  margin-bottom: 10px;
  padding: 8px 12px;
  border-radius: 4px;
}

@media (max-width: 900px) {
  .clan-modal-wrapper:not(.dark-theme) .disciple-list-row {
    grid-template-columns: 34px minmax(0, 1fr) 70px 68px;
  }

  .clan-modal-wrapper:not(.dark-theme) .disciple-map,
  .clan-modal-wrapper:not(.dark-theme) .disciple-rank {
    display: none;
  }
}

@media (max-width: 600px) {
  .clan-modal-wrapper:not(.dark-theme) .disciple-list-row {
    grid-template-columns: 32px minmax(0, 1fr) 58px;
    gap: 8px;
    padding: 8px 4px;
  }

  .clan-modal-wrapper:not(.dark-theme) .disciple-meta {
    display: none;
  }

  .clan-modal-wrapper:not(.dark-theme) .disciple-main span {
    font-size: 10px;
  }

  .clan-modal-wrapper:not(.dark-theme) .treasure-item {
    grid-template-columns: minmax(0, 1fr);
    gap: 7px;
  }

  .clan-modal-wrapper:not(.dark-theme) .treasure-actions,
  .clan-modal-wrapper:not(.dark-theme) .item-actions {
    justify-content: flex-start;
  }

  .clan-modal-wrapper:not(.dark-theme) .xinfa-item {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-rows: auto auto auto;
    gap: 6px 10px;
  }

  .clan-modal-wrapper:not(.dark-theme) .xinfa-header,
  .clan-modal-wrapper:not(.dark-theme) .xinfa-desc {
    grid-column: 1 / -1;
  }

  .clan-modal-wrapper:not(.dark-theme) .xinfa-progress {
    grid-column: 1;
    grid-row: 3;
  }

  .clan-modal-wrapper:not(.dark-theme) .xinfa-status {
    grid-column: 2;
    grid-row: 3;
  }

  .clan-modal-wrapper:not(.dark-theme) .xinfa-actions {
    grid-column: 1 / -1;
    grid-row: 4;
    text-align: left;
  }
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-panel {
  height: 100%;
  overflow-y: auto;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-panel > .ivu-alert {
  margin-bottom: 10px;
  padding: 8px 12px;
  border-radius: 4px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-item {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  min-height: 72px;
  padding: 10px 12px;
  border: 1px solid #dfe9f5;
  border-left: 3px solid #2d8cf0;
  border-radius: 6px;
  background: #fff;
  box-shadow: none;
  transition: border-color .18s ease, background .18s ease;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-item:hover {
  border-color: #9fc9f2;
  border-left-color: #2d8cf0;
  background: #f7faff;
  box-shadow: none;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-icon {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border: 1px solid #cfe3fb;
  border-radius: 6px;
  color: #2d8cf0;
  background: #edf5ff;
  font-size: 20px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-main {
  min-width: 0;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-head,
.clan-modal-wrapper:not(.dark-theme) .treasure-hall-meta,
.clan-modal-wrapper:not(.dark-theme) .treasure-hall-materials {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 12px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-head {
  gap: 8px;
  margin-bottom: 4px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-head .item-name {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #17233d;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-status {
  flex: 0 0 auto;
  padding: 2px 6px;
  border: 1px solid #cfe3fb;
  border-radius: 3px;
  color: #2d8cf0;
  background: #edf5ff;
  font-size: 10px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-meta {
  color: #808695;
  font-size: 11px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-materials {
  margin-top: 5px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-materials .material {
  margin: 0;
  padding: 2px 6px;
  border: 1px solid #e3ebf5;
  border-radius: 3px;
  color: #515a6e;
  background: #f7f8fa;
  font-size: 11px;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-item .item-actions {
  justify-content: flex-end;
}

.clan-modal-wrapper:not(.dark-theme) .treasure-hall-item .item-actions >>> .ivu-btn {
  min-width: 60px;
  border-radius: 4px;
}

@media (max-width: 600px) {
  .clan-modal-wrapper:not(.dark-theme) .treasure-hall-item {
    grid-template-columns: 34px minmax(0, 1fr);
    gap: 8px;
    padding: 9px 8px;
  }

  .clan-modal-wrapper:not(.dark-theme) .treasure-hall-icon {
    width: 32px;
    height: 32px;
    font-size: 17px;
  }

  .clan-modal-wrapper:not(.dark-theme) .treasure-hall-item .item-actions {
    grid-column: 2;
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .clan-modal-wrapper:not(.dark-theme) .main-clan-content {
    height: calc(100vh - 18px);
    min-height: 0;
    overflow: hidden;
    background: #fff;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-detail-toolbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    padding: 8px;
    border-radius: 6px;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-detail-toolbar__title h3 {
    overflow: hidden;
    font-size: 17px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-detail-toolbar__actions {
    display: flex;
    gap: 5px;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-detail-toolbar__actions >>> .ivu-btn {
    min-height: 30px;
    padding: 3px 7px;
    border-radius: 4px;
    white-space: nowrap;
  }

  .clan-modal-wrapper:not(.dark-theme) .clan-tabs {
    min-height: 0;
  }

  .clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-bar {
    margin-bottom: 0;
    padding: 5px 4px;
    overflow-x: auto;
    white-space: nowrap;
  }

  .clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-nav-wrap {
    overflow: visible;
  }

  .clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-tab {
    padding: 7px 10px;
    font-size: 12px;
  }

  .clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-content {
    height: calc(100vh - 108px);
    max-height: none;
    overflow-y: auto;
    padding: 10px 8px 22px;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-header-info {
    display: grid;
    grid-template-columns: 64px minmax(0, 1fr);
    gap: 10px;
    padding: 10px;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-avatar-large {
    width: 64px;
    height: 64px;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-main-info {
    min-width: 0;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-description {
    display: -webkit-box;
    margin-bottom: 8px;
    overflow: hidden;
    font-size: 12px;
    line-height: 1.45;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-stats-grid {
    grid-column: 1 / -1;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-summary-band {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-contribution-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-task-layout {
    grid-template-columns: 1fr;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-task-main,
  .clan-modal-wrapper:not(.dark-theme) .sect-task-side {
    min-width: 0;
  }

  .clan-modal-wrapper:not(.dark-theme) .task-item-top {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 6px;
  }

  .clan-modal-wrapper:not(.dark-theme) .task-item-top p {
    display: -webkit-box;
    max-height: 34px;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .clan-modal-wrapper:not(.dark-theme) .task-requirement {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .clan-modal-wrapper:not(.dark-theme) .requirement-name {
    min-width: 0;
    flex-basis: calc(100% - 60px);
  }

  .clan-modal-wrapper:not(.dark-theme) .task-requirement >>> .ivu-btn {
    margin-left: auto;
  }

  .clan-modal-wrapper:not(.dark-theme) .donate-row,
  .clan-modal-wrapper:not(.dark-theme) .donate-row--material {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .clan-modal-wrapper:not(.dark-theme) .donate-row .donate-label {
    width: 100%;
  }

  .clan-modal-wrapper:not(.dark-theme) .donate-card .ivu-select,
  .clan-modal-wrapper:not(.dark-theme) .donate-card .ivu-input-number {
    flex: 1;
    width: auto;
    min-width: 0;
  }

  .clan-modal-wrapper:not(.dark-theme) .search-bar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 6px;
  }

  .clan-modal-wrapper:not(.dark-theme) .search-bar .ivu-btn {
    min-width: 52px;
  }
}

.sect-mobile-tab-nav {
  display: none;
}

.sect-description-wrap {
  position: relative;
  padding-right: 58px;
}

.sect-description-more {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0;
  border: 0;
  color: #2d8cf0;
  background: transparent;
  font-size: 11px;
  cursor: pointer;
}

.sect-description-more:hover {
  color: #1f6fbd;
}

.clan-modal-wrapper:not(.dark-theme) .sect-description {
  display: -webkit-box;
  max-height: 42px;
  margin-bottom: 0;
  overflow: hidden;
  color: #808695;
  font-size: 12px;
  line-height: 1.75;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.sect-description-full {
  max-height: 60vh;
  overflow-y: auto;
  padding: 12px;
  color: #515a6e;
  background: #f7faff;
  border: 1px solid #dfe9f5;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.8;
  white-space: pre-wrap;
}

@media (max-width: 768px) {
  .clan-modal-wrapper:not(.dark-theme) .sect-mobile-tab-nav {
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr) 72px;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    color: #515a6e;
    background: #fff;
    border-bottom: 1px solid #e8eef6;
    touch-action: pan-y;
    overscroll-behavior-x: none;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-mobile-tab-nav > span {
    overflow: hidden;
    color: #2d8cf0;
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-mobile-tab-nav > span small {
    margin-left: 3px;
    color: #808695;
    font-size: 10px;
    font-weight: 400;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-mobile-tab-nav >>> .ivu-btn {
    min-height: 28px;
    padding: 3px 4px;
    border-radius: 4px;
    color: #426581;
    background: #f7fbff;
    border-color: #b9cde0;
    font-size: 10px;
  }

  .clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-bar {
    display: none;
  }

  .clan-modal-wrapper:not(.dark-theme) .clan-tabs >>> .ivu-tabs-content {
    touch-action: pan-y;
    overscroll-behavior-x: none;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-description-wrap {
    padding-right: 0;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-description {
    max-height: 36px;
    padding-right: 52px;
    font-size: 11px;
    line-height: 1.65;
    -webkit-line-clamp: 2;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-description-more {
    right: 0;
    bottom: 0;
  }

  .clan-modal-wrapper:not(.dark-theme) .sect-info-panel {
    padding-bottom: 4px;
  }
}
</style>

<style>
.clan-modal-wrapper:not(.dark-theme) .sect-workspace {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  gap: 16px;
  min-height: 0;
  padding: 16px;
  background: #f5f9fc;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-self: start;
  padding: 10px;
  background: #ffffff;
  border: 1px solid #c9dced;
  border-radius: 8px;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav__title {
  padding: 5px 8px 9px;
  color: #6f8da6;
  border-bottom: 1px solid #e4eef5;
  font-size: 11px;
  font-weight: 700;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 38px;
  padding: 8px 9px;
  color: #426581;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  text-align: left;
  transition: background .16s, border-color .16s, color .16s;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav__item .ivu-icon {
  color: #9ab5c9;
  font-size: 12px;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav__item:hover {
  color: #315a7c;
  background: #f7fbff;
  border-color: #c9dced;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav__item.active {
  color: #ffffff;
  background: #3978b7;
  border-color: #2f669d;
  box-shadow: 0 3px 8px rgba(57, 120, 183, .18);
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav__item.active .ivu-icon {
  color: #e8f4fc;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-main {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #c9dced;
  border-radius: 8px;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs {
  height: 100%;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs .ivu-tabs-bar,
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs > .ivu-tabs-bar {
  display: none;
}
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs .ivu-tabs-content,
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs > .ivu-tabs-content {
  padding: 18px 20px 28px;
  background: #ffffff;
}
.clan-modal-wrapper:not(.dark-theme) .sect-mobile-tab-nav,
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs .ivu-tabs-nav-wrap,
.clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs .ivu-tabs-nav-scroll {
  display: none;
}
@media (max-width: 768px) {
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace {
    display: block;
    height: auto;
    min-height: 0;
    padding: 8px;
    background: #f5f9fc;
  }
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav {
    display: flex;
    flex-direction: row;
    gap: 5px;
    margin-bottom: 8px;
    padding: 5px;
    overflow-x: auto;
    border-radius: 6px;
    scrollbar-width: none;
  }
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav::-webkit-scrollbar {
    display: none;
  }
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav__title {
    display: none;
  }
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav__item {
    flex: 0 0 auto;
    width: auto;
    min-height: 32px;
    padding: 6px 10px;
    white-space: nowrap;
  }
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace-nav__item .ivu-icon {
    display: none;
  }
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace-main {
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-radius: 6px;
  }
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
  }
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs .ivu-tabs-content,
  .clan-modal-wrapper:not(.dark-theme) .sect-workspace-main .clan-tabs > .ivu-tabs-content {
    min-height: 0;
    padding: 12px 10px 20px;
  }
  .clan-modal-wrapper:not(.dark-theme) .sect-mobile-tab-nav {
    display: none;
  }
}
</style>

<style scoped>
/* 移动端统一滚动边界：页签内容区负责滚动，避免内部固定高度互相吞掉滚动空间。 */
@media (max-width: 768px) {
  .main-clan-content {
    display: flex;
    flex-direction: column;
    height: 100% !important;
    min-height: 0 !important;
    overflow: hidden !important;
  }

  .sect-workspace {
    display: flex !important;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0 !important;
  }

  .sect-workspace-main,
  .sect-workspace-main .clan-tabs {
    flex: 1 1 auto;
    min-height: 0 !important;
  }

  .sect-workspace-main .clan-tabs >>> .ivu-tabs-content,
  .sect-workspace-main .clan-tabs > .ivu-tabs-content {
    display: block;
    flex: 1 1 auto;
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    overscroll-behavior: contain;
    touch-action: pan-y;
  }

  .sect-workspace-main .clan-tabs >>> .ivu-tabs-content-animated,
  .sect-workspace-main .clan-tabs >>> .ivu-tabs-tabpane,
  .sect-workspace-main .clan-tabs >>> .ivu-tabs-tabpane-active {
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
  }

  .sect-info-panel,
  .sect-task-panel,
  .special-building-panel,
  .sect-favor-panel,
  .disciples-panel,
  .treasure-panel,
  .treasure-hall-panel,
  .xinfa-panel,
  .message-board-panel {
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
  }

  .disciples-list,
  .treasure-list,
  .treasure-hall-list,
  .xinfa-list,
  .message-list {
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
  }

  /* 移动端只保留页签内容区滚动，避免任务/弟子内容变长时挤压心法按钮。 */
  .main-clan-content,
  .sect-workspace,
  .sect-workspace-main,
  .sect-workspace-main .clan-tabs {
    min-height: 0 !important;
  }

  .sect-workspace {
    height: 0 !important;
    overflow: hidden !important;
  }

  .sect-workspace-main {
    height: 0 !important;
    overflow: hidden !important;
  }

  .sect-workspace-main .clan-tabs {
    height: 100% !important;
    overflow: hidden !important;
  }

  .sect-workspace-main .clan-tabs >>> .ivu-tabs-content,
  .sect-workspace-main .clan-tabs > .ivu-tabs-content {
    height: 100% !important;
    max-height: none !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  .sect-workspace-main .clan-tabs >>> .ivu-tabs-content-animated,
  .sect-workspace-main .clan-tabs >>> .ivu-tabs-tabpane,
  .sect-workspace-main .clan-tabs >>> .ivu-tabs-tabpane-active {
    height: 100% !important;
    min-height: 0 !important;
  }

  .clan-modal-wrapper .xinfa-item {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) auto !important;
    grid-template-rows: auto auto auto auto !important;
    gap: 6px 10px !important;
  }

  .clan-modal-wrapper .xinfa-header,
  .clan-modal-wrapper .xinfa-desc {
    grid-column: 1 / -1 !important;
  }

  .clan-modal-wrapper .xinfa-progress {
    grid-column: 1 !important;
    grid-row: 3 !important;
  }

  .clan-modal-wrapper .xinfa-status {
    grid-column: 2 !important;
    grid-row: 3 !important;
  }

  .clan-modal-wrapper .xinfa-actions {
    display: flex !important;
    grid-column: 1 / -1 !important;
    grid-row: 4 !important;
    flex-wrap: wrap;
    gap: 5px;
    justify-content: flex-start;
    text-align: left !important;
    white-space: normal !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ClanModal.vue